
const translations = {
    "Notice!": "Забелязвам!",
    "Are you sure that you want to delete this?": "Наистина ли искате да изтриете това?",
    "Confirm": "Потвърждаване",
    "Cancel": "Отказ",
    "Min": "Мин",
    "Max": "Максимум",
    "Before": "Преди",
    "After": "След",
    "w": "с",
    "week": "седмица",
    "weeks": "седмици",
    "d": "д",
    "day": "ден",
    "days": "дни",
    "Due date": "Due date",
    "Start date": "Start date",
    "Internal date": "Internal date",
    "Notes": "Бележки",
    "Document": "Документ",
    "Email": "Имейл",
    "Billing": "Фактуриране",
    "Add": "Добави",
    "Archived": "Архивирано",
    "Cancelled": "Отменен",
    "Active": "Активен",
    "Inactive": "Неактивни",
    "Client company": "Компания клиент",
    "General info": "General info",
    "Digitisation of client documents": "Digitisation of client documents",
    "Client portal": "Клиентски портал",
    "Documents": "Documents",
    "Members": "Членове",
    "Preferences": "Предпочитания",
    "Yes": "Да",
    "No": "Не",
    "Total hours": "Общо часове",
    "Extra hours": "Допълнителни часове",
    "Client": "Client",
    "Tasks": "Задачи",
    "Disable Uku’s task templates": "Забраняване на шаблоните за задачи на Uku",
    "Set the estimation as time when the exact value is not entered": "Set the estimation as the time, if the exact value is not entered",
    "Checklist must be completed to finish the task": "Контролният списък трябва да бъде попълнен, за да завършите задачата",
    "Disable topic management for members": "Забрани управлението на теми за членове",
    "Disable time edit for members": "Забрани редактирането на времето за членове",
    "Allow time entries in future": "Позволяване на времеви записи в бъдеще",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Клиенти",
    "Disable adding new clients for members": "Забрани добавянето на нови клиенти за членове",
    "Only administrators can edit documents": "Само администраторите могат да редактират документи",
    "Allow digitisation of client documents": "Allow digitisation of client documents",
    "Use my Microsoft account": "Use my Microsoft account",
    "Disconnect my Microsoft account": "Disconnect my Microsoft account",
    "Connect my Microsoft account": "Connect my Microsoft account",
    "Use my google account": "Use my Google account",
    "Connect my google account": "Connect my google account",
    "Disconnect my google account": "Disconnect my google account",
    "Emails": "Имейли",
    "Daily agenda": "Дневен дневен ред",
    "Unread notifications": "Непрочетени известия",
    "Task assigned to me": "Задача, възложена ми",
    "Weekly summary": "Седмично резюме",
    "Monthly summary": "Месечно обобщение",
    "Updates and tips": "Актуализации и съвети",
    "Overdue": "Просрочен",
    "1 day": "1 ден",
    "1 day overdue": "1 ден просрочие",
    "{0} days": "{0} дни",
    "{0} days overdue": "{0} просрочени дни",
    "{0} minute ago": "{0} minute ago",
    "{0} minutes ago": "{0} minutes ago",
    "{0} hour ago": "{0} hour ago",
    "{0} hours ago": "{0} hours ago",
    "Sunday": "Неделя",
    "Monday": "Понеделник",
    "Tuesday": "Вторник",
    "Wednesday": "Сряда",
    "Thursday": "Четвъртък",
    "Friday": "Петък",
    "Saturday": "Събота",
    "Sun": "Sun",
    "Mon": "Mon",
    "Tue": "Tue",
    "Wed": "Wed",
    "Thu": "Thu",
    "Fri": "Fri",
    "Sat": "Sat",
    "January": "Януари",
    "February": "Февруари",
    "March": "Март",
    "April": "Април",
    "May": "May",
    "June": "Юни",
    "July": "Юли",
    "August": "Август",
    "September": "Септември",
    "October": "Октомври",
    "November": "Ноември",
    "December": "Декември",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dec",
    "Today": "Днес",
    "Yesterday": "Вчера",
    "Day": "Day",
    "Days": "Дни",
    "+{0} d": "+{0} г",
    "+{0} wd": "+{0} г",
    "Weekly {0}": "Седмичен {0}",
    "Every {0}. week {1}": "Всеки {0}. седмица {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Месечно {0}. d",
    "Every {0}. month {1}. d": "Всеки {0}. месец {1}. d",
    "{0}. d": "{0}. г",
    "Quarterly {0}. month {1}. d": "Тримесечни {0}. месец {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Всеки {0}. квартал {1}. месец {2}. d",
    "{0}. month {1}. d": "{0}. месец {1}. d",
    "Yearly {0}": "Годишно {0}",
    "Every {0}. year {1}": "Всеки {0}. Година {1}",
    "Mo": "По",
    "Tu": "Вт",
    "We": "Ср",
    "Th": "Че",
    "Fr": "Пе",
    "Sa": "Съ",
    "Su": "Не",
    "and": "и",
    "{0}w": "{0}w",
    "{0}d": "{0} г",
    "before": "преди",
    "after": "след",
    "Project": "Проект",
    "Quarter": "Квартал",
    "Add your photo": "Добавяне на снимка",
    "Adding file failed": "Неуспешно добавяне на файл",
    "Please check the file.": "Please check the file",
    "You can only add pictures.": "You can only add pictures",
    "Error": "Грешка",
    "Create new topic": "Създаване на нова тема",
    "Name": "Име",
    "Close": "Затвори",
    "Find topic...": "Търсене на тема...",
    "New topic": "Нова тема",
    "Invalid format": "Невалиден формат",
    "Demo company account": "Демо фирмена сметка",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demo account will be deleted later. Use this for testing purposes only!",
    "Subscribe": "Абонирайте се",
    "Start demo": "Започни демо",
    "End demo": "Край на демото",
    "Free trial is expired - {0}": "Free trial has expired - {0}",
    "Free trial {1} {2} left - {0}": "Остава безплатен пробен период {1} {2} - {0}",
    "Add time": "Добавяне на време",
    "Billable": "Платима",
    "Date": "Дата",
    "Start": "Старт",
    "End": "Край",
    "Duration": "Продължителност",
    "Split duration equally": "Разделяне на продължителността по равно",
    "Required field": "Please fill required field",
    "Members list": "Списък на членовете",
    "Edit fields": "Редактиране на полета",
    "Maximum number of selected columns has been exceeded": "Надвишен е максималният брой избрани колони",
    "If you want to add a new column to the report, please remove an existing one first.": "Ако искате да добавите нова колона към отчета, първо премахнете съществуващата.",
    "Snooze until...": "Отлагайте докато...",
    "Select date & time": "Изберете дата & час",
    "Tomorrow": "Утре",
    "Later this week": "По-късно тази седмица",
    "Next week": "Следваща седмица",
    "Add task": "Добавяне на задача",
    "Checklist": "Списък за проверка",
    "Start timer": "Стартов таймер",
    "Add an item": "Добавяне на библиотечен документ",
    "Add checklist item": "Добавяне на елемент от контролен списък",
    "Convert to a task": "Конвертиране в задача",
    "Delete": "Изтрий",
    "Delegate to...": "Делегат на...",
    "Please select tasks from the same account": "Изберете задачи от същия акаунт",
    "Follow": "Следвай",
    "Expand sidebar": "Expand sidebar",
    "Nicely done!": "Добре направено!",
    "You've finished all your tasks, take a second to recharge": "Приключили сте с всичките си задачи, отделете секунда за презареждане",
    "Search tasks...": "Задачи за търсене...",
    "Search": "Търсене",
    "select/unselect all": "Избери/отмени избора на всички",
    "Add new client": "Добавяне на нов клиент",
    "Account": "Профил",
    "Client name": "Име на клиента",
    "Select client": "Изберете клиент",
    "New client": "Нов клиент",
    "Must be an integer": "Трябва да е цяло число",
    "Must be a number": "Трябва да е число",
    "Dashboard": "Табло",
    "Calendar": "Календар",
    "Report": "Отчет",
    "Monitoring": "Мониторинг",
    "Suppliers": "Доставчици",
    "Events": "Events",
    "Projects": "Проекти",
    "Help": "Помощ",
    "Settings & Apps": "Settings & Apps",
    "Profile": "Профил",
    "Collapse menu": "Collapse menu",
    "Expand menu": "Expand menu",
    "Are you sure to delete this attachment?": "Are you sure you want to delete this attachment?",
    "Select": "Избери",
    "Edit contacts": "Edit contacts",
    "Add member": "Добави член",
    "Add note": "Добавете Бележка",
    "Open": "Open",
    "Reports": "Reports",
    "Billing notes": "Billing notes",
    "Pinned notes": "Закачени бележки",
    "Sub-companies": "Sub-companies",
    "Contacts": "Контакти",
    "Event info": "Event info",
    "Project info": "Project info",
    "Summary": "Резюме",
    "Task": "Задача",
    "Time": "Time",
    "Collapse sidebar": "Collapse sidebar",
    "Client Overview": "Client Overview",
    "Event Overview": "Event Overview",
    "Project Overview": "Project Overview",
    "Edit client": "Редактиране на клиент",
    "Edit event": "Редактиране на събитие",
    "Edit project": "Edit project",
    "Show all": "Покажи всички",
    "Collapse": "Collapse",
    "by": "от",
    "View all": "Виж всички",
    "Add company event": "Add company event",
    "Company": "Организация",
    "Info": "Информация",
    "Holiday": "Отпуска",
    "All day(s)": "All day(s)",
    "End date": "Крайна дата",
    "From": "From",
    "Until": "Until",
    "Hours": "Hours",
    "Link": "Връзка",
    "Save": "Запази",
    "Are you sure that you want to delete this company calendar event?": "Are you sure that you want to delete this company calendar event?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Добавяне на нова роля",
    "New role": "Нова роля",
    "Access enabled": "Достъпът е разрешен",
    "Waiting for files": "Изчакване на файлове",
    "Uploaded": "Качено",
    "Uploading...": "Качване...",
    "Client members": "Клиентски членове",
    "Email settings": "Настройки за имейл",
    "Or connect new email address": "Или свържете нов имейл адрес",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Свързване с Microsoft Exchange или друг имейл сървър (SMTP)",
    "Test email sent": "Изпратен е тестов имейл",
    "Email address": "Имейл адрес",
    "Reply address": "Адрес за отговор",
    "Sender name": "Име на подателя",
    "Who can use?": "Кой може да използва?",
    "Client default address": "Адрес по подразбиране на клиента",
    "Invalid e-mail": "Невалиден имейл",
    "Role": "Роля",
    "E-mail": "Email",
    "Mobile phone": "Mobile phone",
    "Work phone": "Work phone",
    "Language": "Език",
    "Birthday": "Дата на раждане",
    "Are you sure to delete this contact?": "Are you sure you want to delete this contact?",
    "Manage contact fields": "Manage contact fields",
    "Administrative Assistant": "Административен сътрудник",
    "Board member": "Член на Управителния съвет",
    "CEO": "CEO",
    "Add contact": "Добавяне на контакт",
    "Contact person": "Contact person",
    "Leave page?": "Are you sure you want to leave the page?",
    "Changes that you made may not be saved": "Промените, които сте направили, може да не бъдат записани",
    "Leave": "Отпуски",
    "Super! We're importing your clients...": "Супер! Ние внасяме вашите клиенти...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Чувствайте се свободни да напуснете тази страница. Ще изскочим известие, когато вносът е готов. След това трябва да потвърдите клиентите, които искате да добавите към Uku.",
    "Please wait...": "Моля, изчакайте...",
    "Setup API keys": "Настройка на API ключове",
    "You have two options": "Имате две възможности",
    "how to setup API keys": "How to set up API keys",
    "Continue": "Продължи",
    "Custom import": "Импортиране по избор",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "To import clients and volume of work from !INTEGRATION, Uku needs an !INTEGRATION API key for every client.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=\"font-weight-medium\">Продължи</span> - Uku автоматично създава API ключове за всеки клиент",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=\"font-weight-medium\">Персонализиран внос</span> - Uku се свързва само със съществуващите ключове UKU API. Създаване на API ключове ръчно в ! ИНТЕГРАЦИЯ преди внос. Чета:",
    "(it takes a lot of time)": "(отнема много време)",
    "Import Clients": "Импортиране на клиенти",
    "Country": "Държава",
    "Please choose your country": "Моля, изберете вашата държава",
    "Password": "Парола",
    "Start import": "Започни импортирането",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Insert !INTEGRATION login details (it’s secure) to give one-time access to import clients and API keys. Please note that you will be logged out from !INTEGRATION in other browsers.",
    "Update invoice status": "Актуализиране на състоянието на фактурата",
    "Update now": "Актуализирай сега",
    "Daily @ 14:00": "Ежедневно @ 14:00",
    "Daily @ 18:00": "Ежедневно @ 18:00",
    "Updating invoice statuses, please wait...": "Актуализиране на статусите на фактурите, моля изчакайте...",
    "Your import is ready": "Импортирането ви е готово",
    "In the final step you need to confirm the clients you want to add to uku": "В последната стъпка трябва да потвърдите клиентите, които искате да добавите към uku",
    "Let's go": "Да вървим",
    "Import again": "Импортиране отново",
    "Do you have new clients to import?": "Имате ли нови клиенти за импортиране?",
    "Yes, i do": "Yes, I do",
    "View last import": "Преглед на последното импортиране",
    "Email server": "Имейл сървър",
    "Email provider": "Доставчик на електронна поща",
    "Host": "Домакин",
    "Port": "Порт",
    "Security": "Сигурност",
    "Sender email": "Имейл на подателя",
    "Username": "Потребителско име",
    "Test connection": "Тестване на връзката",
    "How to set up": "Как да настроите",
    "Only administrators can activate the app": "Само администраторите могат да активират приложението",
    "You are in the waiting list": "You are in the waiting list",
    "We onboard all applicants one by one": "We onboard all applicants one by one",
    "Connected": "Свързан",
    "Activated": "Активирано",
    "Join waiting list": "Join waiting list",
    "Activate": "Активиране",
    "Unsubscribe from waiting list": "Unsubscribe from waiting list",
    "Deactivate app": "Деактивиране на приложение",
    "Disconnect": "Disconnect",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "Email not delivered",
    "Sent, but fallback to Uku email": "Sent, but fallback to Uku email",
    "Unknown error": "Неизвестна грешка",
    "to": "до",
    "in any minute": "at any minute",
    "on {0},": "на {0},",
    "or": "или",
    "Send now": "Изпрати сега",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>изпраща</span> имейл",
    "__From_email": "From",
    "Set up email": "Настройване на имейл",
    "Client default": "Клиент по подразбиране",
    "Subject": "Тема",
    "Edit email": "Редактиране на имейл",
    "Template": "Шаблон",
    "Cc": "Як",
    "Bcc": "Ск",
    "__To_email": "To",
    "__Cc_email": "Cc",
    "__Bcc_email": "Bcc",
    "Add template": "Добави шаблон",
    "Add automation": "Добавяне на автоматизация",
    "Add placeholder": "Добавяне на контейнер",
    "Format text": "Форматиране на текст",
    "Add attachment": "Добавяне на прикрепен файл",
    "Send": "Изпрати",
    "Save automation": "Запазване на автоматизацията",
    "Choose email template": "Избор на шаблон за имейл",
    "All languages": "Всички езици",
    "No templates found.": "Не са намерени шаблони.",
    "Edit email template": "Редактиране на шаблон за имейл",
    "Are you sure you want to delete this template? Some tasks will be affected": "Наистина ли искате да изтриете този шаблон? Някои задачи ще бъдат засегнати",
    "Are you sure you want to delete this template?": "Наистина ли искате да изтриете този шаблон?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Are you sure you want to save this template? The following tasks will be affected:",
    "Template name": "Име на шаблон",
    "Edit template": "Редактиране на шаблон",
    "Send email": "Изпрати имейл",
    "on": "включено",
    "Ok": "Добре",
    "Supplier": "Доставчик",
    "Event": "Event",
    "Contact": "Контакт",
    "Validation failed": "Validation failed",
    "Saving supplier failed": "Saving supplier failed",
    "Saving client failed": "Saving client failed",
    "Saving project failed": "Saving project failed",
    "several values": "няколко стойности",
    "values": "Стойности",
    "is": "е",
    "Add filter": "Добавяне на филтър",
    "Update": "Обновяване",
    "forever": "Завинаги",
    "Last week": "Предишна седмица",
    "This week": "Тази седмица",
    "Last month": "Миналия месец",
    "This month": "Този месец",
    "Next month": "Следващият месец",
    "Last year": "Миналата година",
    "This year": "Тази година",
    "This quarter": "Това тримесечие",
    "Next quarter": "Следващо тримесечие",
    "Last quarter": "Последно тримесечие",
    "Client group": "Клиентска група",
    "Topic": "Topic",
    "Member": "Член",
    "Primary member": "Основен член",
    "Client status": "Състояние на клиента",
    "Active clients": "Активни клиенти",
    "Inactive clients": "Неактивни клиенти",
    "All": "Всички",
    "Project status": "Състояние на проекта",
    "Member status": "Статус на член",
    "Active members": "Активни членове",
    "Limited members": "Limited members",
    "Inactive members": "Неактивни членове",
    "Contract status": "Статус на договора",
    "Active contracts": "Активни договори",
    "Pending contracts": "Висящи договори",
    "Finished contracts": "Завършени договори",
    "Contract template": "Шаблон за договор",
    "Payment recurrence": "Повторяемост на плащането",
    "Yearly": "Годишно",
    "Monthly": "Месечно",
    "Trial": "Пробен период",
    "Region": "Регион",
    "Field": "Поле",
    "All tasks": "Всички задачи",
    "Todo": "To do",
    "Not done": "Не е готово",
    "Done": "Готово",
    "Delayed": "Забавено",
    "Important": "Важно",
    "Extra work": "Допълнителна работа",
    "I Follow": "Следвам",
    "Commented": "Коментира",
    "Tracked time": "Проследено време",
    "Estimated": "Очаква",
    "Recurring task": "Повтаряща се задача",
    "Last import": "Последно импортиране",
    "Period": "Период",
    "Client search": "Търсене на клиенти",
    "Voucher": "Voucher",
    "Company status": "Company status",
    "Deleted": "Изтрито",
    "All status": "All status",
    "Payment gateway": "Payment gateway",
    "All gateways": "All gateways",
    "Uku manually": "Uku manually",
    "Braintree": "Braintree",
    "Plan status": "Plan status",
    "All plans": "All plans",
    "Paid": "Платено",
    "Paid churn": "Paid churn",
    "Trial churn": "Trial churn",
    "Plan period": "Plan period",
    "All periods": "All periods",
    "Monthly plan": "Monthly plan",
    "Yearly plan": "Yearly plan",
    "Company search": "Търсене на фирма",
    "User search": "Търсене на потребител",
    "Name key search": "Търсене на ключ за име",
    "None filter": "None",
    "OK": "ОК",
    "Start date cannot be later than due date": "Start date cannot be later than due date",
    "tasks": "задачи",
    "task(s) had errors": "task(s) have errors",
    "tasks selected": "избрани задачи",
    "Postpone": "Отсрочвам",
    "Mark done": "Маркирай като готово",
    "Hide multiselect": "Скрий множествения избор",
    "Delete task(s)": "Изтриване на задача(и)",
    "All of the data related to the task will be deleted": "Всички данни, свързани със задачата, ще бъдат изтрити",
    "Some tasks include other people. Are you sure you want to delete?": "Some tasks include other people. Are you sure you want to delete?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Time has been tracked to some of the selected activities. Are you sure you want to delete?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?",
    "task(s) were not marked done": "Задачата (задачите) не е маркирана като завършена",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Please check that the checklist is complete, the time has been entered, and the task is assigned to you",
    "task(s) were not deleted": "Задачата(ите) не са изтрити",
    "task(s) time was not updated": "task(s) time was not updated",
    "Please make sure that you can add time to task": "Please make sure that you can add time to task",
    "invoice table row": "ред на таблица с фактури",
    "invoice table row(s) had errors": "invoice table row(s) have errors",
    "invoice table row(s) selected": "Избрани редове от таблица с фактури",
    "Create": "Създаване",
    "Mark paid": "Марк платен",
    "Send to client": "Send to client",
    "Recalculate": "Преизчисляване",
    "Export to {0}": "Export to {0}",
    "Update Status from {0}": "Update Status from {0}",
    "Void invoice": "Невалидна фактура",
    "Delete invoice": "Изтриване на фактура",
    "Restore invoice": "Възстановяване на фактура",
    "Mark unpaid": "Маркиране като неплатено",
    "Invoices": "Фактури",
    "Download to Excel": "Изтегляне в Excel",
    "Revenue split": "Revenue split",
    "Tax": "Данък",
    "Description": "Описание",
    "Percent": "Процент",
    "Integration Id": "Integration Id",
    "Integration Code": "Integration Code",
    "Name on invoice": "Name on invoice",
    "Restore": "Възстановяване",
    "Archive": "Архив",
    "Hide": "Hide",
    "Are you sure?": "Сигурен ли сте?",
    "Import finished!": "Импортирането завърши!",
    "Failed to import {0} records": "Failed to import {0} records",
    "Download report": "Download report",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Result: added {0}, updated {1}, skipped {2}, failed to import {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Result: added {0}, updated {1}, skipped {2}",
    "What’s next?": "Какво следва?",
    "To work effectively with your client base, complete the following steps:": "За да работите ефективно с клиентската си база, изпълнете следните стъпки:",
    "Read more ›": "Прочети повече ›",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "След това ще виждате само активни импортирани клиенти. За да видите всички клиенти, премахнете филтъра \"Последно импортиране\".",
    "View clients": "Преглед на клиенти",
    "Add <b>primary member</b> to every client.": "Добавяне на <b>основен член</b> към всеки клиент.",
    "Add <b>task plan</b> to automate recurring tasks.": "Добавете <b>план за задачи</b> за автоматизиране на повтарящи се задачи.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Настройте автоматично месечно обобщение под приложението {0} в Uku, за да импортирате обема на работата.",
    "Title": "Title",
    "Field type": "Тип",
    "Field name": "Field name",
    "Group name": "Име на група",
    "Choices": "Избор",
    "Type each choice on a separate line": "Въведете всеки избор на отделен ред",
    "Required": "Задължително",
    "For all topics": "For all topics",
    "For specific topics": "For specific topics",
    "Topics": "Теми",
    "Non-billable": "Не се таксува",
    "Edit task custom field": "Редактиране на поле по избор на задача",
    "Add task custom field": "Добавяне на поле по избор на задача",
    "Edit client custom field": "Редактиране на клиентско персонализирано поле",
    "Add client custom field": "Добавяне на клиентско поле по избор",
    "Choice {0}": "Избор {0}",
    "Are you sure that you want to delete this custom field?": "Are you sure you want to delete this custom field?",
    "Warning!": "Внимание!",
    "This custom field is in use. Do you wish to archive it?": "This custom field is in use. Do you want to archive it?",
    "Reconnect": "Reconnect",
    "Send test email": "Изпрати тестов имейл",
    "Email address or username": "Имейл адрес или потребителско име",
    "Other": "Друго",
    "Set default email server for company": "Задаване на имейл сървър по подразбиране за фирма",
    "My default email": "Моят имейл по подразбиране",
    "Depends on": "Зависи",
    "Todo - Blocking": "To do - Blocking",
    "In progress - Blocking": "В процес на изпълнение - Блокиране",
    "In progress": "В процес на изпълнение",
    "Client code": "Клиентски код",
    "Primary user": "Основен потребител",
    "Added date": "Дата на добавяне",
    "Updated": "Обновена на",
    "Contract count": "Брой договори",
    "Integration": "Интеграция",
    "No data available": "No data available",
    "No results found": "No results found",
    "Loading": "Loading",
    "Sort by": "Sort by",
    "Rows per page": "Rows per page",
    "{0}-{1} of {2}": "{0}-{1} на {2}",
    "Ongoing": "Текущ",
    "important": "Important",
    "Read more": "Прочети повече",
    "Add to previous time entry": "Добавяне към предишния запис за час",
    "Add to next time entry": "Добави към следващия запис за време",
    "Add new task": "Добавяне на нова задача",
    "Cut previous time entry": "Изрязване на предишния запис за време",
    "Cut next time entry": "Изрежи следващия път влизане",
    "Missing time entry": "Липсващ запис за време",
    "Overlapping time entries": "Припокриващи се записи за време",
    "Member from custom fields": "Member from custom fields",
    "Delegated to": "Делегирано на",
    "Delegated by": "Делегирано от",
    "Visible members": "Visible members",
    "Member type": "Member type",
    "Groups": "Групи",
    "Custom field": "Потребителско поле",
    "Contact search": "Contact search",
    "Task start": "Task start",
    "Task due": "Task due",
    "Task finish": "Task finish",
    "Custom date": "Custom date",
    "Never": "Never",
    "Agreed work is still expected": "Agreed work is still expected",
    "Accepted flextime": "Accepted flextime",
    "Declined flextime": "Declined flextime",
    "Cancelled flextime": "Cancelled flextime",
    "Updated flextime": "Updated flextime",
    "Calendar deleted": "Calendar deleted",
    "Calendar created": "Calendar created",
    "Calendar approved": "Calendar approved",
    "Calendar declined": "Календарът е отклонен",
    "Calendar updated": "Календарът е актуализиран",
    "Flextime balance updated": "Балансът на гъвкавото време е актуализиран",
    "Flextime": "Гъвкаво време",
    "Vacation": "Vacation",
    "Balance": "Баланс",
    "Comment": "Коментар",
    "History": "История",
    "Action": "Действие",
    "Who": "Кой",
    "Take a vacation or mark an absence": "Вземете си отпуск или отбележете отсъствие",
    "Away": "Далеч",
    "Flextime bonus": "Flextime bonus",
    "Approver": "Одобряващ",
    "Vacation available": "Vacation available",
    "Type": "Type",
    "Reduce agreed working hours": "Намаляване на договореното работно време",
    "Reject": "Отхвърли",
    "Approve": "Одобри",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Sick leave",
    "Parental leave": "Parental leave",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Общо",
    "Settings": "Настройки",
    "Work on holidays": "Work on holidays",
    "Expand": "Разгръщане",
    "Wait until event status": "Изчакайте, докато състоянието на събитието",
    "Wait until project status": "Изчакайте, докато състоянието на проекта",
    "Week(s)": "Седмица (и)",
    "Day(s)": "Ден(и)",
    "Rule": "Правило",
    "Depends on event": "Depends on event",
    "Depends on project": "Depends on project",
    "Due date in": "Дата на падеж в",
    "Status": "Статус",
    "Select event": "Select event",
    "Select project": "Select project",
    "Find event...": "Find event...",
    "Find project...": "Find project...",
    "Custom recurrence": "Повторение по избор",
    "Every": "Every",
    "In case of holiday": "В случай на почивка",
    "Set time": "Задаване на време",
    "Start time": "Начален час",
    "Repeat from": "Repeat from",
    "Previous repeat from: {0}": "Previous repeat from: {0}",
    "On date": "На дата",
    "Plus days": "Плюс дни",
    "Due date time": "Дата на падеж и час",
    "Remove recurrence": "Remove recurrence",
    "Repeat": "Повторение",
    "month": "месец",
    "quarter": "тримесечие",
    "year": "година",
    "1st month": "1-ви месец",
    "2nd month": "2-ри месец",
    "3rd month": "3-ти месец",
    "Day {0}": "Ден {0}",
    "Show before": "Покажи преди",
    "Keep the day": "Запазете деня",
    "Show after": "Покажи след",
    "From start date": "От началната дата",
    "From beginning of the month": "От началото на месеца",
    "All days (Mon to Sun)": "Всички дни (пн до нед)",
    "Mon to Fri (incl. holidays)": "Пн до Пет (вкл. празници)",
    "Mon to Fri (excl. holidays)": "Пн до Пет (с изключение на празниците)",
    "1st": "1-ви",
    "2nd": "2-ри",
    "3rd": "3-ти",
    "Does not repeat": "Не се повтаря",
    "Daily": "Ежедневно",
    "Weekly on {0}": "Седмично по {0}",
    "Monthly on day {0}": "Месечно на ден {0}",
    "Quarterly on {0} month {1} day": "Тримесечно на {0} месец {1} ден",
    "Yearly on {0} {1}": "Годишно на {0} {1}",
    "Custom...": "Обичай...",
    "Incorrect time": "Неправилно време",
    "Add repeat": "Add recurrence",
    "Email added to queue": "Имейлът е добавен към опашката",
    "Communication timeline": "Времева линия на комуникацията",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Активирайте Email App в App Store, за да изпращате автоматизирани имейли и да преглеждате миналата и бъдещата си комуникация на едно място.",
    "Go to App Store": "Отидете в App Store",
    "Unknown": "Неизвестно",
    "<b>Email</b> from": "<b>Email</b> from",
    "To": "Дo",
    "Planned": "Планиран",
    "Automated emails scheduled to be sent in the future": "Emails scheduled to be sent during the next 45 days",
    "Send e-mail": "Изпрати e-mail",
    "Template unlinked": "Шаблонът не е свързан",
    "Icon": "Икона",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Видимо",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Company default",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Намери член...",
    "I'll take it": "Ще го взема",
    "Remove me": "Премахни ме",
    "Remove from task": "Премахване от задача",
    "Learn more": "Научете още",
    "Company settings edit is disabled by owner": "Company settings edit is disabled by owner",
    "<b>Exported</b> {0} to {1}": "<b>Exported</b> {0} to {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Paid {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Annulled</b> {0}",
    "Do you wish to mark the task done for everyone?": "Искате ли да отбележите задачата, изпълнена за всички?",
    "No, remove me": "Не, отстранете ме",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Task won’t be marked done, but user will be removed from the assignees and added to the followers of the task",
    "Invalid email": "Invalid email",
    "Accounting": "Счетоводство",
    "General": "Основни",
    "Advertising / Marketing/ PR": "Реклама / Маркетинг / PR",
    "Architecture": "Архитектура",
    "Construction": "Конструкция",
    "Consulting - IT, software": "Консултиране - ИТ, софтуер",
    "Consulting - Management": "Консултиране - Мениджмънт",
    "Finance": "Финанси",
    "Legal": "Правен",
    "Medicine / Pharmacy ": "Медицина / Фармация ",
    "Non-profit": "С нестопанска цел",
    "Web design": "Уеб дизайн",
    "Web development": "Web development",
    "Max 140 characters": "Максимум 140 символа",
    "Please complete the checklist": "Моля, попълнете контролния списък",
    "It is required to mark all checklist items as done": "Необходимо е да маркирате всички елементи от контролния списък като завършени",
    "Please enter time spent": "Моля, въведете прекараното време",
    "Inserting time is essential for this client": "Вмъкването на време е от съществено значение за този клиент",
    "Only me": "Само аз",
    "Private": "Личен",
    "Edit note": "Редактиране на бележка",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Добавете допълнителна информация за клиента, като специални споразумения, пароли и др.",
    "Edit": "Редактирай",
    "Workdays": "Работни дни",
    "Workhours": "Работно време",
    "Weeks": "Weeks",
    "Clear filters": "Изчисти филтрите",
    "Save filters": "Запазване на филтрите",
    "Expected": "Expected",
    "Estimation": "Оценка",
    "Do you also want to postpone the due date?": "Искате ли също да отложите датата на падежа?",
    "{0} week": "{0} week",
    "{0} weeks": "{0} weeks",
    "Vacations": "Vacations",
    "Holidays": "Holidays",
    "Tax dates": "Tax dates",
    "Accounting news": "Accounting news",
    "Company events": "Company events",
    "Member birthdays": "Member birthdays",
    "Contact birthdays": "Contact birthdays",
    "Group items": "Group items",
    "Don't group": "Не групирай",
    "{0} away": "{0} away",
    "Member birthday | Member birthdays": "Member birthday | Member birthdays",
    "Contact birthday | Contact birthdays": "Contact birthday | Contact birthdays",
    "Contact birthday": "Contact birthday",
    "Member birthday": "Member birthday",
    "Are you sure you wish to delete this link?": "Are you sure you want to delete this link?",
    "Reference name": "Референтно име",
    "Reference link": "Референтна връзка",
    "Free trial": "Пробен период",
    "Solo": "Einsam",
    "Team": "Екип",
    "Enterprise": "Предприятие",
    "Mini Uku": "Мини Уку",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome browser plugin for Uku to manage your tasks, clients and track time.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Настройте планове за задачи/проекти, за да автоматизирате работния си поток, да добавяте теми, персонализирани полета и да променяте предпочитанията си.",
    "Setup client groups, custom fields and modify your preferences.": "Настройване на клиентски групи, персонализирани полета и промяна на предпочитанията ви.",
    "test": "test",
    "Anti Money Laundering": "Anti-Money Laundering",
    "Setup your customer AML and get instant reminders when auditing is due.": "Настройте AML на клиентите си и получавайте незабавни напомняния, когато предстои одит.",
    "flextime_description": "flextime_description",
    "Smart Accounts": "Интелигентни акаунти",
    "Automatically imports work statistics from your accounting software.": "Автоматично импортира статистически данни за работата от вашия счетоводен софтуер.",
    "Merit Aktiva": "Заслуга Актива",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Ускорете процеса на фактуриране на клиента си с ценови листи и интелигентни договори.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Визуалният отчет ще ви каже точно колко печеливш или нерентабилен е вашият клиент.",
    "Emailing description": "Send emails directly from Uku and automate recurring emails",
    "e-conomic": "е-кономичен",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Синхронизиране на клиентски данни от Uku към e-conomic и обратно. Преглед на информацията в книгата за продажби за всеки клиент.",
    "Xero": "Xero",
    "xero_description": "xero_description",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Скоро",
    "Export sales invoices.": "Експортни фактури за продажби.",
    "Fortnox": "Fortnox",
    "fortnox_description": "fortnox_description",
    "Magic button": "Магически бутон",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "С едно кликване - бърз и лесен начин за създаване на важни задачи. Например, телефонно обаждане от клиент.",
    "With suppliers, you make your projects and partners management more efficient.": "С доставчиците правите управлението на вашите проекти и партньори по-ефективно.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Мощното и гъвкаво управление на проекти обслужва различни случаи на употреба и работни процеси.",
    "client_portal_app_description": "client_portal_app_description",
    "Chat": "Chat",
    "chat_app_description": "chat_app_description",
    "Companies House": "Companies House",
    "companies_house_app_description": "companies_house_app_description",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Connect and discover tools to help you manage your business.",
    "Subscribe now": "Subscribe now",
    "Compare plans": "Compare plans",
    "Add company": "Add company",
    "BETA": "BETA",
    "Setup": "Настройка",
    "Power up": "Захранване нагоре",
    "Integrations": "Интеграции",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hi! Do you want to work with a team and use extra features? No problem, first add your company!",
    "Read more about Uku plans": "Read more about Uku plans",
    "Contact role": "Роля на контакта",
    "Contact roles": "Контактни роли",
    "Client groups": "Клиентски групи",
    "Client fields": "Client fields",
    "Contact fields": "Contact fields",
    "View archive": "Виж архива",
    "Restore from archive": "Възстановяване от архива",
    "Empty list": "Празен списък",
    "Task fields": "Task fields",
    "task topics": "Теми на задачите",
    "Keep the task opened when starting the timer": "Keep the task open when starting the timer",
    "task templates": "шаблони за задачи",
    "Author": "Автор",
    "Duplicate": "Дублирай",
    "Uku task templates": "Uku task templates",
    "Are you sure that you want to delete this task template?": "Наистина ли искате да изтриете този шаблон за задача?",
    "Templates": "Шаблони",
    "Overview": "Преглед",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Colour",
    "Are you sure to delete this field? You may lose the data.": "Are you sure you want to delete this field? You may lose the data.",
    "Add field": "Добави поле",
    "Add section": "Add section",
    "multiline": "многоредов",
    "Import data": "Импортиране на данни",
    "Automate data collection with Smart Accounts": "Automate data collection with Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Импортиране на записи за покупки и продажби, общ брой записи и редове за записи;</li><li>Автоматизиране на събирането на данни със Smart Accounts;</li><li>По-бързо и по-точно фактуриране чрез автоматизиран обмен на данни. Uku събира информация за изготвяне на фактурите на клиентите на едно място и прави фактурирането ефективно.</li></ul>",
    "xero_app_overview_text": "xero_app_overview_text",
    "Import clients from {0}": "Импортиране на клиенти от {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Before importing clients, you need to authorize with Xero and select the Company.",
    "Authorize Xero to start import": "Authorize Xero to start import",
    "Failed to import clients": "Failed to import clients",
    "Failed to connect to WS": "Failed to connect to WS",
    "Import": "Импорт",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "Email signatures",
    "Everyone": "Всички",
    "Access": "Достъп",
    "Creator": "Автор",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Имейл адреси",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku сигурно се интегрира с вашия имейл, за да ви помогне да управлявате и автоматизирате комуникацията",
    "Use {0} address": "Use {0} address",
    "connect your email address": "свързване на вашия имейл адрес",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Свързване с Microsoft Exchange или друг имейл сървър (SMTP)",
    "Email integration reconnected": "Email integration reconnected",
    "Are you sure you want to delete this email integration?": "Наистина ли искате да изтриете тази интеграция с имейл?",
    "Email templates": "Шаблони за имейл",
    "Add email template": "Добавяне на шаблон за имейл",
    "Are you sure you want to save this template? Some tasks will be affected": "Наистина ли искате да запишете този шаблон? Някои задачи ще бъдат засегнати",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "<p class='title'>Connect with e-conomic to keep your clients and invoices in sync</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku</li><li>import classificators from e-conomic to Uku</li><li>create invoices in Uku and then export them to e-conomic</li></ul></p></div>",
    "Default layout": "Оформление по подразбиране",
    "Change agreement ID": "ИД на споразумение за промяна",
    "Failed to connect to server": "Failed to connect to server",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku will import all clients, client’s info and classificators. In the final step you can select which clients you want to add or update.",
    "Connect e-conomic": "Свържете e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Before importing clients, you need to connect Uku and e-conomic software. To do this, create e-conomic agreement and enter the agreement ID here.",
    "Step {0}": "Стъпка {0}",
    "Get agreement ID": "Получаване на ИД на споразумение",
    "Insert agreement ID": "Вмъкване на ИД на споразумение",
    "Connect": "Свързване",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with QuickBooks.": "Before importing clients, you need to connect with QuickBooks.",
    "Connected to QuickBooks": "Connected to QuickBooks",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.",
    "Before importing clients, you need to connect with Fortnox.": "Before importing clients, you need to connect with Fortnox.",
    "Connect to Fortnox": "Connect to Fortnox",
    "Connected to Fortnox": "Connected to Fortnox",
    "Delete template": "Изтриване на шаблон",
    "Public": "Публичен",
    "Workflow templates": "Шаблони за работни потоци",
    "No workflow templates yet": "Все още няма шаблони за работни потоци",
    "Modified": "Променено",
    "Uku workflow templates": "Uku workflow templates",
    "Are you sure you wish to delete this workflow?": "Are you sure you want to delete this workflow?",
    "Project fields": "Полета на проекта",
    "Progress step": "Стъпка на напредъка",
    "Rename project": "Преименуване на проект",
    "Project statuses": "Статуси на проекта",
    "You can use the statuses to restrict the workflow.": "Можете да използвате състоянията, за да ограничите работния поток.",
    "Project phases": "Project phases",
    "Make your progress beautiful.": "Направете напредъка си красив.",
    "Permissions": "Разрешения",
    "Users can manage workflow templates": "Потребителите могат да управляват шаблони за работни потоци",
    "project_app_overview_text": "Streamline the entire project lifecycle from initiation to completion.",
    "project_app_overview_description": "<div class='body-2'><p>It is now easier than ever to plan, execute, and track your projects efficiently.</p><p>Key features:</p><ul><li><b>Project creation: </b>Easily create and set up new projects with customisable project templates or start from scratch.</li><li><b>Task management: </b>Break down projects into tasks, assign responsibilities, set due dates and dependencies.</li><li><b>Progress tracking: </b>Visualise project progress and task dependencies with the interactive projects overview, helping you manage project schedules effectively.</li><li><b>Resource allocation: </b>Assign team members and monitor workload to optimise resource utilisation.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and with the help of workflow templates.</li></ul></div>",
    "Configure summary task": "Конфигуриране на обобщена задача",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku will generate a task with the following title and topic on the last day of the month.",
    "Task title": "Заглавие на задачата",
    "Recurrence": "Повтаряне",
    "Count changes from previous periods": "Count changes from previous periods",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.",
    "Configure data fields": "Конфигуриране на полета с данни",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Select the corresponding Uku field for each imported field. Same fields will be summarised. By leaving a field blank it will be ignored.",
    "New custom field": "Ново персонализирано поле",
    "Show more": "Покажи повече",
    "Every month": "Every month",
    "Last day of the month": "Последен ден от месеца",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Ден {0} на следващия месец",
    "Settings saved": "Settings saved",
    "Uku will let you know when it is ready.": "Uku will let you know when it is ready.",
    "Reload data": "Reload data",
    "months": "months",
    "This will overwrite existing summary tasks new values.": "This will overwrite existing summary tasks new values.",
    "Overwrite": "Overwrite",
    "Automate your anti money laundering process": "Automate your anti-money laundering process",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "You are about to activate the anti-money laundering process. During this, new additional fields will be added to your client's data and also the system will begin reminding you to update them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Status</il><li>Document No.</il><li>Document valid until</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "You are about to activate the anti-money laundering process. During this, new additional fields will be added to your client's data and also the system will begin reminding you to update them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>",
    "Do not change client custom fields created by Uku": "Works with client custom field created by Uku",
    "day(s) before": "ден(и) преди",
    "Task name": "Име на задачата",
    "Assigned": "Присвоен",
    "Note": "Бележка",
    "Manual run": "Ръчно изпълнение",
    "Create a task when the document expires": "Създаване на задача, когато срокът на документа изтече",
    "Create a task when the risk profile must be updated": "Създаване на задача, когато рисковият профил трябва да се актуализира",
    "Flextime period": "Flextime period",
    "Confirmation period": "Confirmation period",
    "Weekly": "Седмично",
    "Add agreement": "Add agreement",
    "flextime_app_overview_text": "flextime_app_overview_text",
    "supplier_app_overview_text": "Manage your partners and vendors.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organisations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Supplier type",
    "Parent type": "Тип родител",
    "Edit supplier type": "Редактиране на типа доставчик",
    "New supplier type": "Нов тип доставчик",
    "Are you sure you wish to delete this supplier type?": "Are you sure you want to delete this supplier type?",
    "Types": "Видове",
    "Supplier types": "Видове доставчици",
    "No supplier types yet": "Все още няма видове доставчици",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.",
    "Connect Tripletex": "Connect Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.",
    "Get employee token": "Get employee token",
    "Insert employee token": "Insert employee token",
    "Install": "Инсталирай",
    "Open Chrome browser to install": "Отворете браузъра Chrome, за да инсталирате",
    "Works with your online accounting software.": "Работи с вашия онлайн счетоводен софтуер.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Новите задачи могат да ударят като светкавица и затова Mini Uku е най-добрият ви приятел. Без значение дали извършвате банкови преводи или работите със счетоводен софтуер; с Mini Uku можете да добавяте нови задачи, да проследявате времето и да следите всичките си известия от всеки уебсайт.<br><br>Само едно кликване върху иконата на бухал осигурява преглед на целия ви работен ден и ви помага да планирате графика си по-ефективно.",
    "merit_aktiva_app_overview_text_pl": "<p class='title'>Importuj klientów i ilość pracy, aby otrzymać jeden raport z danymi dotyczącymi wykonanej pracy dla wszystkich klientów.</p><div class='body-2'><p>Spraw, aby zbieranie danych było szybkie i dokładne dzięki integracji 360 Księgowość i Uku. Uku automatycznie importuje faktury sprzedaży i zakupu, dokumenty, wpisy, itd. dla każdego klienta i zbiera nakład pracy oraz wpisy czasowe w jednym, interaktywnym raporcie. Koniec z przełączaniem się między klientami w oprogramowaniu księgowym w celu uzyskania informacji o przetworzonych dokumentach, aby utworzyć faktury lub monitorować wydajność klienta. W porównaniu do 360 Księgowość, Uku importuje rzeczywistą liczbę wpisów z ostatniego miesiąca, biorąc pod uwagę wszystkie zmiany, które zostały wprowadzone do poprzednich okresów. Oznacza to, że nie musisz zapamiętywać ani zapisywać żadnych zmian, które wprowadziłeś - Uku ma wszystkie te informacje i Ty też będziesz je mieć. Zautomatyzowane zbieranie danych oszczędza Twój czas i eliminuje błąd ludzki.</p><p>Integracja Uku i 360 Księgowość pomaga Ci:</p><p><ul><li>Szybko i dokładnie zbierać dane - ilość pracy jest automatycznie importowana do Uku z 360 Księgowość</li><li>Analizować obciążenie pracą i czas dzięki dostępowi do pełnego podsumowania wykonanej pracy i czasu spędzonego na klientach</li><li>Zautomatyzować tworzenie zestawień miesięcznych</li><li>Uzyskać przegląd rzeczywistego obciążenia pracą w każdym miesiącu</li></ul></p><p>Dzięki integracji Uku - 360 Księgowość możesz zaimportować:</p><p><ul><li>Dokumenty</li><li>Wpisy</li><li>Faktury przedaży</li><li>Faktury kupna</li><li>Operacje bankowe</li><li>Operacje gotówkowe</li><li>Wpisy VAT</li><li>Zapisy zasobów</li><li>Itd.</li></ul></p></div>",
    "merit_aktiva_app_overview_text": "<p class='title'>Import clients and the volume of work to get one report with work done data for all your clients.</p><div class='body-2'><p>Make your data collection fast and accurate with Merit Aktiva and Uku integration. Uku automatically imports sales and purchase invoices, documents, entries, etc. for each client and performs volume of work and time-entries in one interactive report. No more switching between clients in your accounting software to get information about documents processed to create invoices or monitor client performance. Compared to Merit, Uku imports the actual amount of entries for last month, taking into account all changes that were inserted into previous periods. Meaning that you don't have to remember or write down any changes you have made - Uku has all that information and so will you. Automated data collection saves you time and eliminates human errors.</p><p>Uku and Merit Aktiva integration helps you to:</p><p><ul><li>Quickly and accurately gather data - volume of work is imported to Uku from Merit automatically</li><li>Analyse workload and time by having a full overview of work done and time spent on clients</li><li>Automate the creation of monthly summaries </li><li>Get an overview of the actual workload each month</li></ul></p><p>With Uku - Merit integration you can import the amount of:</p><p><ul><li>Documents</li><li>Entries</li><li>Sales invoices</li><li>Purchase invoices</li><li>Bank entries</li><li>Cash entries</li><li>VAT entries</li><li>Stock entries</li><li>Etc.</li></ul></p></div>",
    "Import clients": "Импортиране на клиенти",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "You are about to disconnect this service.": "You are about to disconnect this service.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Обновяване",
    "Be aware of the issues before they become problems": "Бъдете наясно с проблемите, преди те да се превърнат в проблеми",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Сравнение в реално време на клиентски договор и реално извършена работа;</li><li>Бъдете наясно с проблемите, преди те да се превърнат в проблеми;</li><li>Дори и с фиксирани цени трябва да имате вътрешни измервания. Следете валидността на съгласието на клиента, като го сравнявате с действителното количество извършена работа.</li></ul>",
    "client_portal_app_overview_text": "client_portal_app_overview_text",
    "Branding": "Поставяне на търговска марка",
    "Subdomain": "Поддомейн",
    "Default language": "Език по подразбиране",
    "Client portal URL in other languages": "URL адрес на клиентски портал in other languages",
    "Copy URL": "Копиране на URL адрес",
    "Trademark": "Търговска марка",
    "Trademark text color": "Цвят на текста на търговската марка",
    "Choose color": "Изберете цвят",
    "Brand background color": "Цвят на фона на марката",
    "Logo": "Лого",
    "Delete logo": "Изтриване на емблема",
    "Upload logo file": "Качване на файл с емблема",
    "Max. dimensions 180 x 60 px": "Макс. размери 180 x 60 пиксела",
    "Favicon": "Favicon",
    "Delete icon": "Икона за изтриване",
    "Upload icon file": "Качване на файл с икони",
    "Recommended size 260 x 260 px": "Препоръчителен размер 260 x 260 px",
    "Company description": "Описание на фирмата",
    "Displayed on the login page.": "Показва се на страницата за вход.",
    "Describe here what services you offer and how you help your clients.": "Опишете тук какви услуги предлагате и как помагате на клиентите си.",
    "Welcome video": "Приветствено видео",
    "Displayed on the login page when your client contact enters for the first time": "Показва се на страницата за вход, когато вашият клиентски контакт влезе за първи път",
    "Use Uku video": "Use Uku video",
    "View": "View",
    "Use other video": "Use other video",
    "Youtube or Vimeo video URL": "Youtube or Vimeo video URL",
    "Show file upload box for client tasks": "Show file upload box for client tasks",
    "Invalid data": "Invalid data",
    "Client portal preview": "Client portal preview",
    "Client portal URL for {0} copied to clipboard": "Client portal URL for {0} copied to clipboard",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Add recurring task": "Добавяне на повтаряща се задача",
    "Reminder tasks updated": "Reminder tasks updated",
    "Create recurring tasks for Companies House clients.": "Create recurring tasks for Companies House clients.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "Бутони",
    "Show to me": "Show me",
    "magic_button_app_overview_text": "<p class='title'>With one click, add a new task and start the timer.</p> <div class='body-2'><p>Magic buttons allow you to insert urgent work (phone call, email) conveniently.</p><p>Insert all tasks immediately to Uku</p><p>Magic buttons allow you to add urgent tasks (phone call, email) to Uku conveniently. That ensures tasks are inserted into Uku properly.</p><p>Magic buttons:</p><ul><li>Insert a new task and start the timer with one click (move to + button in the header).</li><li>Customize magic buttons according to your needs.</li><li>Modify the client or other information afterward.</li><li>Continue with the previous task that you can quickly access from the magic buttons list.</li></ul></div>",
    "Buttons": "Бутони",
    "Member rights": "Member rights",
    "Allow managers to view and create their client contracts and invoices": "Позволяване на мениджърите да преглеждат и създават своите клиентски договори и фактури",
    "Allow members to view and create their client invoices": "Позволяване на членовете да преглеждат и създават своите клиентски фактури",
    "Allow members to view their client invoices": "Позволяване на членовете да преглеждат своите клиентски фактури",
    "Allow only owners to add and update products": "Позволяване само на собствениците да добавят и актуализират продукти",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Позволяване на членовете да потвърждават своите редове за фактури на клиенти",
    "Send PDF invoice": "Изпращане на PDF фактура",
    "Invoice email": "Имейл за фактура",
    "Default rounding": "Default rounding",
    "Round all times up to x": "Round all times up to x",
    "Time rounding increment": "Time rounding increment",
    "Apply time rounding to": "Apply time rounding to",
    "Default configuration": "Default configuration",
    "Invoice date": "Дата на фактура",
    "Invoice entry date": "Invoice entry date",
    "Bill tracked time by": "Bill tracked time by",
    "Bill task field by": "Bill task field by",
    "Create one invoice merging invoices from the same period": "Create one invoice merging invoices from the same period",
    "Invoices from the same period": "Invoices from the same period",
    "Hide zero sum lines": "Hide zero sum lines",
    "By default, time entry is billable": "By default, time entry is billable",
    "Invoice number": "Номер на фактура",
    "Prefix": "Префикс",
    "Suffix": "Наставка",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Настройките за фактуриране са запазени",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimising human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Product",
    "Contract templates": "Шаблони за договори",
    "Invoice templates": "Шаблони за фактури",
    "Tools": "Tools",
    "Replace tax": "Replace tax",
    "Old tax": "Old tax",
    "New tax": "New tax",
    "Find tax": "Find tax",
    "Replace VAT in products": "Replace VAT in products",
    "Replace VAT in master contracts": "Replace VAT in master contracts",
    "Replace VAT in client contracts & draft invoices": "Replace VAT in client contracts & draft invoices",
    "Replace VAT values": "Replace VAT values",
    "This action cannot be undone": "This action cannot be undone",
    "Replace": "Замени",
    "Result": "Result",
    "PDF templates": "PDF шаблони",
    "E-mail templates": "Email templates",
    "Edit PDF template": "Редактиране на PDF шаблон",
    "Import classificators": "Импортиране на класификатори",
    "products": "продукти",
    "product": "продукт",
    "Product / service": "Продукт / услуга",
    "Calculate": "Изчислете",
    "Article": "Статия",
    "Resource": "Resource",
    "Cost center": "Cost center",
    "Taxes": "Taxes",
    "Code": "Код",
    "Source": "Източник",
    "Articles": "Articles",
    "Resources": "Resources",
    "Cost centers": "Cost centers",
    "Units": "Units",
    "Unit": "Мерна единица",
    "Bank accounts": "Bank accounts",
    "Bank account": "Bank account",
    "Bank name": "Име на Банка",
    "IBAN": "IBAN",
    "SWIFT code": "СУИФТ код",
    "Do you wish to import only new data or also overwrite existing?": "Do you wish to import only new data or also overwrite existing?",
    "Only new": "Only new",
    "New items will be added. Existing ones will remain unchanged by import.": "New items will be added. Existing ones will remain unchanged by import.",
    "Import everything": "Import everything",
    "Connect accounting service": "Свържете счетоводна услуга",
    "Service": "Услуга",
    "API ID": "ИД на API",
    "API key": "Ключ за API",
    "Company Account Id": "Company Account ID",
    "Api secret": "API secret",
    "E-conomic": "E-conomic",
    "SmartAccounts": "Смарт акаунти",
    "Test": "Тест",
    "Lock time entries": "Lock time entries",
    "Owner rights": "Owner rights",
    "Disable company settings edit for all members": "Disable company settings edit for all members",
    "Disable personal clients for members": "Disable personal clients for members",
    "Show member birthdays": "Show member birthdays",
    "Show contact birthdays": "Show contact birthdays",
    "Weekly @ Sun {0}": "Weekly @ Sun {0}",
    "Monthly @ last day of month": "Monthly @ last day of month",
    "Company event list": "Company event list",
    "How long?": "How long?",
    "Invoice no.": "Фактура No.",
    "Login options": "Login options",
    "Tenant ID (optional)": "Tenant ID (optional)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Добавете ИД на клиент на Active Directory, ако само потребители, принадлежащи към този клиент, имат право да се свързват",
    "How to find ID’s?": "Как да намерите документи за самоличност?",
    "Microsoft connected": "Свързан с Microsoft",
    "Google connected": "Свързан с Google",
    "Edit company": "Редактиране на фирма",
    "Timezone": "Часова зона по подразбиране на сървъра",
    "VAT number": "ИН по ДДС",
    "Company number": "ЕИК",
    "Subscription plan": "Абонаментен план",
    "Payment failed": "Неуспешно плащане",
    "Retry payment": "Повторен опит за плащане",
    "Next payment": "Следващо плащане",
    "Update payment method": "Актуализиране на метода на плащане",
    "Plan": "план",
    "Choose a plan": "Изберете план",
    "Change plan": "Edit plan",
    "{0}-day free trial until {1}": "{0}-дневен безплатен пробен период до {1}",
    "monthly": "месечно",
    "yearly": "ежегодно",
    "{0} member": "{0} член",
    "{0} members": "{0} членове",
    "{0} plan": "{0} план",
    "Cancelled (valid until {0})": "Отменено (валидно до {0})",
    "Your trial expired on {0}": "Срокът на пробния ви период изтече на {0}",
    "Your subscription expired on {0}": "Вашият абонамент е изтекъл на {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Радвам се да те видя! Ако искате да започнете работа с абонамент за Uku, щракнете върху Избор на план",
    "Save {0} by paying for a year!": "Спестете {0}, като платите за една година!",
    "Choose plan": "Изберете план",
    "Pay annually": "Плащайте годишно",
    "Instructions sent!": "Инструкциите са изпратени!",
    "Instructions for resetting your password have been sent to": "Инструкции за нулиране на паролата са изпратени на",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "You’ll receive this email within 5 minutes. Be sure to check your spam folder too.",
    "Back to login page": "Обратно към страницата за вход",
    "Get new password": "Получете нова парола",
    "Pick a password": "Create a password",
    "Use minimum 8 characters with letters & numbers": "Minimum 8 characters using both letters & numbers",
    "Create your Uku Account": "Създайте своя Uku акаунт",
    "Connect your Xero Account": "Свържете вашия Xero акаунт",
    "Phone": "Телефон",
    "I agree to the": "Съгласен съм с",
    "Terms of Service": "Условия за ползване",
    "Next": "Следващ",
    "Having trouble?": "Имате проблеми?",
    "We can help": "Ние можем да помогнем",
    "Log in instead": "Влезте вместо това",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "No 1 инструмент за счетоводни практики. Автоматизирани работни потоци, проследяване на времето, отчети, мониторинг, CRM. Вършете работата си навреме и изгодно. Опитайте безплатно!",
    "You are invited to join": "Поканени сте да се присъедините",
    "Accept invitation": "Приемане на покана",
    "Check your email": "Проверете имейла си",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Изпратих ви имейл с линк за активиране на акаунта ви. Това е важно, за да се гарантира сигурността на вашия акаунт.",
    "Go to": "Отиди на",
    "Need a new password?": "Need to reset your password?",
    "Enter your e-mail address and we will send you directions for changing your password": "Въведете Вашия имейл адрес и ние ще Ви изпратим упътвания за смяна на паролата",
    "Send me instructions": "Изпратете ми инструкции",
    "Never mind, go back": "Няма значение, върни се",
    "No login options enabled. Please contact the company owner": "Няма разрешени опции за влизане. Моля, свържете се със собственика на фирмата",
    "Log in to Uku": "Влезте в Uku",
    "Forgot password?": "Забравена парола?",
    "Don't have account?": "Don't have an account?",
    "Create account": "Създаване на акаунт",
    "Total items:": "Общо артикули:",
    "Add new": "Добавете нов",
    "Amount": "Сума",
    "Account created range": "Създаден от акаунт диапазон",
    "Usage limit": "Ограничение за използване",
    "Valid until": "Валиден до",
    "Edit help link": "Редактиране на връзка за помощ",
    "New help link": "Нова връзка за помощ",
    "Name key": "Ключ за име",
    "Country code": "Код на страната",
    "Period (months)": "Период (месеци)",
    "Account created from": "Акаунт, създаден от",
    "Account created until": "Акаунтът е създаден до",
    "Used count": "Използван брой",
    "Sum": "Сума",
    "Create voucher": "Създаване на ваучер",
    "Edit voucher": "Редактиране на ваучер",
    "Are you sure to delete this voucher?": "Are you sure you want to delete this voucher?",
    "row | rows": "ред | Редове",
    "Add event": "Добавяне на събитие",
    "Are you sure you wish to delete this event?": "Are you sure you want to delete this event?",
    "event | events": "събитие | Събития",
    "Security object id": "ИД на защитен обект",
    "Direct rights": "Преки права",
    "Computed rights": "Изчислени права",
    "Add link": "Добавете връзка",
    "Are you sure you wish to delete this entry?": "Are you sure you want to delete this entry?",
    "link | links": "линк | Връзки",
    "Event type": "Вид на събитието",
    "Date from": "Дата от",
    "Date until": "Дата до",
    "Shortened by h": "Съкратено с h",
    "Category": "Категория",
    "demo | demos": "демо | Демонстрации",
    "Companies": "Компании",
    "Leads": "Лидове",
    "Demos": "Демонстрации",
    "Vouchers": "Ваучери",
    "KPI": "KPI",
    "Activity log": "Регистър на дейностите",
    "Notifications": "Известия",
    "Me": "Мен",
    "Important notifications will appear here.": "Тук ще се появят важни известия.",
    "Back": "Назад",
    "Return to UKU": "Return to Uku",
    "Choose plan for {0}": "Изберете план за {0}",
    "First payment will be made after the end of the trial period.": "Първото плащане ще бъде направено след края на пробния период.",
    "Members and subscription can always be changed.": "Членовете и абонаментът винаги могат да бъдат променени.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Период на фактуриране",
    "Compare features": "Сравни характеристиките",
    "Cancel uku subscription": "Cancel Uku subscription",
    "{0} discount": "{0} отстъпка",
    "You have currently<br />{0} active member": "В момента имате<br />{0} активен член",
    "You have currently<br />{0} active members": "В момента имате<br />{0} Активни членове",
    "Select yearly plan": "Изберете годишен план",
    "Select monthly plan": "Изберете месечен план",
    "Attention!": "Внимание!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Ако искате да използвате Uku безплатно, деактивирайте профила си и продължете с {0} план",
    "per member/month (billed yearly)": "на член/месец (таксува се годишно)",
    "or {0} per member/month (monthly)": "or {0} per member/month (billed monthly)",
    "Everything in {0}, plus:": "Всичко в {0}, плюс:",
    "Compare plans, feature-by-feature": "Сравняване на планове, функция по функция",
    "Deactivate account": "Дезактивиране на акаунт",
    "Are you sure to deactivate {0} account?": "Are you sure you want to deactivate {0} account?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Ако решите да продължите с плана за фрийлансър, фирменият ви акаунт ще бъде деактивиран. Данните, които са свързани с тази фирма, ще бъдат премахнати.",
    "Deactivate": "Деактивирайте",
    "Teamwork": "Екип",
    "Unlimited clients + import": "Неограничени клиенти + внос",
    "Access management": "Управление на достъпа",
    "Custom fields": "Персонализирани полета",
    "Live chat support": "Онлайн чат",
    "AML": "АМЛ",
    "API": "API",
    "Client Portal": "Клиентски портал",
    "New!": "Нов!",
    "Custom integrations": "Персонализирани интеграции",
    "Assisted clients import": "Импортиране на асистирани клиенти",
    "Tailor-made team workshop": "Екипна работилница по поръчка",
    "Early access to features": "Ранен достъп до функции",
    "Pay by invoice": "Плащане по фактура",
    "Dedicated account manager": "Специализиран акаунт мениджър",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Здравей! Процесът ви приключи. Моля, изберете абонаментния {0} план, за да продължите работата си",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Здравей! Трябва да надстроите абонаментния {0} план, за да използвате тази функция",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "Edit VAT number": "Edit VAT number",
    "VAT": "ДДС",
    "This is subscription period amount.": "Това е сумата за периода на абонамента.",
    "You save yearly {0}": "You save yearly {0}",
    "Add voucher": "Добави ваучер",
    "Existing credit": "Съществуващ кредит",
    "Current payment": "Текущо плащане",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.",
    "Confirm subscription {0}": "Confirm subscription {0}",
    "Your subscription will renew on": "Your subscription will renew on",
    "Thank you for believing in us!": "Thank you for believing in us!",
    "Uku team": "Uku team",
    "Voucher {1} (-{0}%)": "Voucher {1} (-{0}%)",
    "Voucher {0}": "Ваучер {0}",
    "New plan": "Нов план",
    "Changed plan": "Changed plan",
    "Add {0} member": "Add {0} member",
    "Add {0} members": "Add {0} members",
    "Remove {0} member": "Remove {0} member",
    "Remove {0} members": "Remove {0} members",
    "No changes to plan": "No changes to plan",
    "Discount -{0}% with Yearly subscription": "Discount -{0}% with yearly subscription",
    "Yearly discounted price (-{0}%)": "Yearly discounted price (-{0}%)",
    "Subscription updated": "Subscription updated",
    "Please wait": "Моля, изчакайте",
    "Your payment failed": "Плащането ви е неуспешно",
    "Please check that you entered the data correctly or use another card": "Моля, проверете дали сте въвели данните правилно или използвате друга карта",
    "Try again": "Опитайте отново",
    "Pay": "Плати",
    "Payment": "Плащане",
    "Payment method updated": "Payment method updated",
    "Edit member": "Редактиране на член",
    "First name": "Име",
    "Last name": "Фамилия",
    "External ID": "External ID",
    "Select groups": "Избор на групи",
    "Administrator": "Администратор",
    "Invite sent": "Invite sent",
    "Activate member": "Activate member",
    "Deactivate member": "Дезактивиране на член",
    "Invited": "Invited",
    "Paid member": "Paid member",
    "Send an invitation": "Send an invitation",
    "Limited": "Limited",
    "No invite, no access": "No invite, no access",
    "Free until activated": "Free until activated",
    "No access, no charge": "No access, no charge",
    "Hidden member": "Hidden member",
    "Edit members": "Редактиране на членове",
    "Select user": "Изберете потребител",
    "Member will be assigned to every selected client": "Член ще бъде назначен на всеки избран клиент",
    "Member will be removed from all selected clients": "Членът ще бъде премахнат от всички избрани клиенти",
    "Assign user": "Присвояване на потребител",
    "Set as primary user": "Задай като основен потребител",
    "Added as a default user when adding a task plan": "Добавен като потребител по подразбиране при добавяне на план за задача",
    "Remove from new tasks": "Премахване от нови задачи",
    "Remove from plan tasks": "Премахване от планиране на задачи",
    "Remove": "Премахни",
    "Admin": "Администратор",
    "Remove user": "Премахване на потребител",
    "Assign to incomplete tasks": "Възлагане на незавършени задачи",
    "Reassign incomplete tasks": "Повторно възлагане на незавършени задачи",
    "Assign to plan tasks": "Assign to plan tasks",
    "Reassign plan tasks": "Повторно възлагане на задачи от план",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Собственикът ще бъде назначен за задачи, ако премахнатият потребител е последният назначен потребител.",
    "Run integration": "Изпълнение на интеграция",
    "Run": "Изпълни",
    "Integration configuration": "Интеграционна конфигурация",
    "Read the manual": "Прочетете ръководството",
    "Api key": "API key",
    "Are you sure to delete this integration info?": "Are you sure you want to delete this integration info?",
    "Edit Contracts": "Редактиране на договори",
    "Replace following contracts": "Замяна на следните договори",
    "Append services to following contracts": "Добавяне на услуги към следните договори",
    "Choose template": "Избор на шаблон",
    "Append only": "Само добавяне",
    "with template": "с шаблон",
    "All existing contracts": "Всички съществуващи договори",
    "All quarterly contracts": "Всички тримесечни договори",
    "All monthly contracts": "Всички месечни договори",
    "All yearly contracts": "Всички годишни договори",
    "Next invoice number": "Номер на следващата фактура",
    "Number is too big, it cannot exceed 15 digits": "Числото е твърде голямо, не може да надвишава 15 цифри",
    "Replace topic": "Replace topic",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "All tasks and plans with current topic will be replaced with the new selected topic.",
    "Topics replaced": "Topics replaced",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?",
    "Name of topic": "Име на темата",
    "Change topic": "Edit topic",
    "Add new topic": "Добавяне на нова тема",
    "This topic is in use. Do you wish to archive it?": "This topic is in use. Do you want to archive it?",
    "Are you sure that you want to delete this topic?": "Are you sure you want to delete this topic?",
    "These items will be deleted permanently": "Тези елементи ще бъдат изтрити окончателно",
    "Are you sure that you want to delete this client group?": "Наистина ли искате да изтриете тази клиентска група?",
    "This client group is in use. Do you wish to archive it?": "Тази клиентска група се използва. Искате ли да го архивирате?",
    "Edit client group": "Редактиране на клиентска група",
    "New client group": "Нова клиентска група",
    "Price": "Цена",
    "Quantity": "Количество",
    "Unit will be translated to client language": "Unit will be translated to client language",
    "Pick date & time": "Избор на дата & час",
    "Share equally": "Share equally",
    "Change existing": "Промяна на съществуваща",
    "Choose bookmark": "Изберете показалец",
    "New title": "Ново заглавие",
    "Set as my default view": "Set as my default view",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Default signature": "Default signature",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Действия",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Желаете ли да актуализирате свързани договори и фактури?",
    "Update contract templates, active contracts and open invoices.": "Update contract templates, active contracts and open invoices.",
    "The following fields will be updated": "Следните полета ще бъдат актуализирани:",
    "Custom Value": "Стойност по избор",
    "This product is in use. Do you wish to archive it?": "This product is in use. Do you want to archive it?",
    "Are you sure that you want to delete this product?": "Наистина ли искате да изтриете този продукт?",
    "Customize for client": "Customize for client",
    "Customize for template": "Customize for template",
    "Open product template": "Open product template",
    "Create product template": "Create product template",
    "Master template": "Master template",
    "Client product": "Client product",
    "Client product / service": "Client product / service",
    "New client product": "New client product",
    "Template product": "Template product",
    "Template product / service": "Template product / service",
    "New template product": "New template product",
    "Edit translations": "Редактиране на преводи",
    "Billable topics": "Billable topics",
    "Billable time": "Billable time",
    "Minimum quantity": "Minimum quantity",
    "Minimum time": "Минимално време",
    "Integration parameters": "Integration parameters",
    "Empty values will use product default": "Empty values will use product default",
    "Pricing": "Цени",
    "DC %": "Отст. %",
    "Sum all matching rows": "Sum all matching rows",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.",
    "Prices since": "Цени от тогава",
    "Add price": "Add price",
    "Add pricing period": "Добавяне на период на ценообразуване",
    "Update contracts": "Update contracts",
    "(Without topic)": "(Без тема)",
    "Fixed price": "Фиксирана цена",
    "Product": "Продукт",
    "Event created": "Event created",
    "Project created": "Project created",
    "Event deleted": "Event deleted",
    "Project deleted": "Project deleted",
    "Workflow added": "Добавен е работен поток",
    "Workflow removed": "Работният поток е премахнат",
    "Workflow updated": "Работният поток е актуализиран",
    "Event cancelled": "Event cancelled",
    "Project cancelled": "Project cancelled",
    "Event reactivated": "Event reactivated",
    "Project reactivated": "Project reactivated",
    "Event archived": "Event archived",
    "Project archived": "Project archived",
    "Event unarchived": "Event unarchived",
    "Project unarchived": "Project unarchived",
    "Event changed": "Event changed",
    "Project changed": "Project changed",
    "Event status changed: {0}": "Event status changed: {0}",
    "Project status changed: {0}": "Project status changed: {0}",
    "Event status changed": "Event status changed",
    "Project status changed": "Project status changed",
    "Task created": "Задачата е създадена",
    "Task changed": "Задачата е променена",
    "Task finished": "Задачата е завършена",
    "Task not finished": "Задачата не е завършена",
    "Task deleted": "Задачата е изтрита",
    "Add project": "Добави проект",
    "Hide filters": "Скрий филтрите",
    "Show filters": "Покажи филтрите",
    "Cancel event": "Cancel event",
    "Cancel project": "Отмени проекта",
    "Manage event fields": "Manage event fields",
    "Manage project fields": "Manage project fields",
    "New event": "New event",
    "New project": "New project",
    "{0} (Copy)": "{0} (копие)",
    "Are you sure you wish to delete this project?": "Are you sure you want to delete this project?",
    "Are you sure to archive this event?": "Are you sure to archive this event?",
    "Are you sure to archive this project?": "Are you sure you want to archive this project?",
    "Are you sure to cancel this event?": "Are you sure to cancel this event?",
    "Are you sure to cancel this project?": "Are you sure you want to cancel this project?",
    "Communication": "Общуване",
    "Log": "Log",
    "Create event workflow": "Create event workflow",
    "Create project workflow": "Create project workflow",
    "Use workflow templates to set up tasks effectively or": "Use workflow templates to set up tasks effectively or",
    "Add tasks manually": "Add task manually",
    "Save bookmark": "Save bookmark",
    "Remove filters": "Премахване на филтри",
    "Filter": "Филтър",
    "Show multiselect": "Показване на множествен избор",
    "To do today": "Да се направи днес",
    "This and next month": "Този и следващия месец",
    "Last 3 months": "Последните 3 месеца",
    "Next 3 months": "Следващите 3 месеца",
    "Starts": "Начало",
    "To do": "За да направите",
    "today": "днес",
    "tomorrow": "утре",
    "yesterday": "вчера",
    "Previous week": "Предишна седмица",
    "Group similar tasks": "Групиране на сходни задачи",
    "Group by client": "Групиране по клиент",
    "Group by date": "Групиране по дата",
    "Group by topic": "Групиране по тема",
    "Your details": "My details",
    "City": "Град",
    "Regional format": "Regional format",
    "Default company": "Default company",
    "Lock time entries notification": "Lock time entries notification",
    "Notify by": "Notify by",
    "Delete my account": "Изтриване на моя акаунт",
    "Attention": "Внимание",
    "Are you sure that you want to delete your account?": "Are you sure you want to delete your account?",
    "Notification": "Notification",
    "Notification & email": "Notification & email",
    "Vacations / absence": "Vacations / absence",
    "Edit balance": "Edit balance",
    "View history": "View history",
    "Request": "Request",
    "How long": "How long",
    "Requested": "Requested",
    "Approved": "Approved",
    "Rejected": "Rejected",
    "In review": "In review",
    "Change": "Edit",
    "Agreements": "Agreements",
    "New agreement": "New agreement",
    "Change agreement": "Change agreement",
    "Stop demo": "Стоп демо",
    "Show": "Покажи",
    "Don't show": "Не показвай",
    "Don't send": "Не изпращай",
    "Email workdays at 7 AM": "Имейл работни дни в 7 часа сутринта",
    "Email at 3 PM": "Имейл в 15:00",
    "Email at once": "Изпращане на имейл наведнъж",
    "Email Sundays at 11 PM": "Електронна поща неделя в 23:00",
    "First day of the month": "Първи ден от месеца",
    "to email": "Email at once",
    "E-mail at once": "Email at once",
    "System": "System",
    "Person": "Човек",
    "Picture": "Снимка",
    "Time zone": "Часова зона",
    "Calendar settings": "Настройки на календара",
    "Public holidays": "Официални празници",
    "Tax deadlines": "Данъчни срокове",
    "News": "Новини",
    "External services": "Външни услуги",
    "Google log in": "Google login",
    "Microsoft log in": "Microsoft log in",
    "Are you sure to remove microsoft?": "Are you sure to remove microsoft?",
    "Agreement": "Agreement",
    "Active agreement": "Active agreement",
    "Weekly hours": "Weekly hours",
    "Are you sure to remove google?": "Are you sure to remove google?",
    "Edit supplier": "Редактиране на доставчик",
    "New supplier": "Нов доставчик",
    "Are you sure you wish to delete this supplier?": "Are you sure you want to delete this supplier?",
    "Add supplier": "Добави доставчик",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Видовете доставчици не са дефинирани. Моля, отидете в настройките на приложението на доставчиците, за да добавите.",
    "No members yet": "Все още няма членове",
    "Edit group": "Редактиране на група",
    "Add group": "Добави група",
    "Are you sure to delete this user group?": "Are you sure you want to delete this user group?",
    "Get set up to work with team": "Get set up to work with a team",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Фирмената сметка ви позволява да използвате инструменти за екипи, да получите по-задълбочени прозрения и т.н. Повишете качеството на работния процес на вашия екип и водете по-печеливш бизнес.",
    "Create company account": "Създаване на фирмен акаунт",
    "By creating a company account you activate Uku free subscription for {0} days.": "By creating a company account you activate your Uku free subscription for {0} days.",
    "You have invited {0}/{1} members": "Поканили сте {0}/{1} членове",
    "Upgrade": "Надграждане",
    "Resend invite": "Повторно изпращане на покана",
    "Send invite": "Send invite",
    "View profile": "View profile",
    "To add members to your team, you'll need to create a company account": "За да добавите членове към екипа си, ще трябва да създадете фирмен акаунт",
    "Export": "Експортиране",
    "Re-invite sent": "Re-invite sent",
    "View report": "Преглед на отчета",
    "Member {0} will be deactivated.": "Държавите-{0} ще бъдат деактивирани.",
    "Please select new member who will replace {0}.": "Моля, изберете нов член, който ще {0} замени.",
    "Select new member": "Изберете нов член",
    "NB! Deactivation process cannot be reversed": "НБ! Процесът на деактивиране не може да бъде обърнат",
    "Magic button settings": "Настройки на магически бутон",
    "Create only one task per month": "Създаване само на една задача на месец",
    "Current month's tasks": "Задачи за текущия месец",
    "extra work": "допълнителна работа",
    "Without topic": "Без тема",
    "Week": "Седмица",
    "Previous month": "Предишния месец",
    "task | tasks": "Задача | Задачи",
    "Assign to": "Възложено на",
    "Mark as done": "Маркирай като направено",
    "Last": "Последно",
    "Snooze": "Snooze",
    "1 dependency": "1 зависимост",
    "{0} dependencies": "{0} зависимости",
    "Client request": "Client request",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Добави коментар",
    "Internal comment": "Internal comment",
    "Portal message": "Portal message",
    "Public message means that clients can read it and the client portal will notify them by email": "Public message means that clients can read it and the client portal will notify them by email",
    "Type a comment": "Въведете коментар",
    "Send portal message": "Send portal message",
    "Open timesheet": "Отваряне на график",
    "Pause timer": "Пауза на таймера",
    "Mark undone": "Маркирай като отменено",
    "Digitise": "Digitise",
    "Documents sent to digitisation": "Documents sent to digitisation",
    "Followers": "Последователи",
    "Start / Due date": "Начало / Краен срок",
    "Select topic": "Изберете тема",
    "1 document": "1 document",
    "{0} documents": "{0} documents",
    "Download": "Изтегляне",
    "Download all": "Download all",
    "Assign as task": "Assign as task",
    "When selected, the task is sent as a task to the client": "Когато е избрана, задачата се изпраща като задача на клиента",
    "Auto finish": "Автоматично довършване",
    "When selected, the task is marked done after client finishes it": "Когато е избрана, задачата се маркира като завършена, след като клиентът я завърши",
    "Add comment / message": "Add comment / message",
    "Add email": "Добавяне на имейл",
    "Add estimation": "Добавяне на оценка",
    "Add task field": "Add task field",
    "Add dependency": "Добавяне на зависимост",
    "Drop files to upload": "Пускане на файлове за качване",
    "Task sent to client portal": "Task sent to client portal",
    "Task no longer assigned to client portal": "Task no longer assigned to client portal",
    "Save recurring task": "Записване на повтаряща се задача",
    "Add to-do list": "Добавяне на списък със задачи",
    "Waiting for event status: {0}": "Waiting for event status: {0}",
    "Waiting for project status: {0}": "Waiting for project status: {0}",
    "Edit template task": "Редактиране на задача за шаблон",
    "Create recurring task": "Създаване на повтаряща се задача",
    "Make a copy": "Създаване на копие",
    "Add topic": "Добави тема",
    "Delete task": "Изтриване на задача",
    "Delete task template": "Изтриване на шаблон за задача",
    "Select task field": "Select task field",
    "No custom fields available for this client": "Няма налични полета по избор за този клиент",
    "task": "задача",
    "recurring task": "повтаряща се задача",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Do you intend to remove yourself from {0} or do you want to delete it completely?",
    "This {1} is shared with {0}": "Тази {1} е споделена с {0}",
    "Remove only me": "Премахни само мен",
    "Time has been tracked to this task.": "Time has been tracked to this task.",
    "Are you sure to delete this task?": "Are you sure to delete this task?",
    "Undefined": "Неопределена",
    "COPY": "КОПИРАМ",
    "On task due date": "On task due date",
    "{0} day before": "{0} ден преди",
    "{0} days before": "{0} дни преди",
    "Edit workflow": "Редактиране на работен поток",
    "Duplicate project": "Дублиран проект",
    "Reset layout": "Нулиране на парола",
    "Any time": "По всяко време",
    "Assign user...": "Присвояване на потребител...",
    "1 min": "1 минута",
    "5 min": "5 минути",
    "10 min": "10 минути",
    "30 min": "30 минути",
    "1 h": "1 час",
    "Add notes": "Добавяне на бележки",
    "Task start date": "Task start date",
    "Task due date": "Task due date",
    "Recurrence task": "Recurring task",
    "Search from one time templates": "Search from one time templates",
    "Placeholders": "Контейнери",
    "New task": "Нова задача",
    "New recurring task": "Нова повтаряща се задача",
    "+1 day": "+1 ден",
    "Edit comment": "Промяна на коментар",
    "Timer is running!": "Таймерът работи!",
    "Continue time from {0}": "Продължете времето от {0}",
    "New time entry": "Въвеждане на нов час",
    "Load more": "Load more",
    "Are you sure to delete this time entry?": "Are you sure you want to delete this time entry?",
    "Save automated email": "Запазване на автоматизиран имейл",
    "Automation": "Автоматизация",
    "Are you sure to delete this email?": "Are you sure you want to delete this email?",
    "Are you sure you wish to send this email immediately?": "Are you sure you want to send this email immediately?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "commented",
    "Reply": "Reply",
    "Are you sure to delete this comment?": "Are you sure you want to delete this comment?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "sent a message",
    "replied to task email": "replied to task email",
    "failed to send": "неуспешно изпращане",
    "sent email": "изпратен имейл",
    "no one": "no one",
    "created this task.": "Създадох тази задача.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "requested assistance.",
    "updated this task.": "актуализира тази задача.",
    "tracked time to this task.": "проследено време до тази задача.",
    "finished this task.": "завърши тази задача.",
    "new comment.": "new comment.",
    "reassigned this task.": "reassigned this task.",
    "assigned the task to {0}.": "assigned the task to {0}.",
    "reminder.": "reminder.",
    "deleted.": "deleted.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "completed the task, but Uku did not auto-finish this task because not all task requirements were met.",
    "sent task to client portal": "sent task to client portal",
    "assigned the task to client.": "assigned the task to client.",
    "assigned the task to company.": "assigned the task to company.",
    "added attachment(s).": "added attachment(s).",
    "added a comment.": "added a comment.",
    "added a message to {0}.": "added a message to {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "updated notes.",
    "made changes to checklist.": "made changes to checklist.",
    "created this task template.": "създаде този шаблон за задача.",
    "updated this task template.": "актуализира този шаблон за задача.",
    "recurring task assigned.": "recurring task assigned.",
    "recurring task deleted.": "recurring task deleted.",
    "added email.": "added email.",
    "changed email.": "changed email.",
    "deleted email.": "deleted email.",
    "sent email.": "sent email.",
    "failed to send.": "failed to send.",
    "added email": "Добавен имейл",
    "changed email": "Променен имейл",
    "deleted email": "изтрит имейл",
    "Member / Time": "Member / Time",
    "Client/topic": "Клиент/тема",
    "Client/task": "Клиент/задача",
    "Client/member": "Клиент/член",
    "Member/topic": "Член/тема",
    "Member/task": "Член/задача",
    "Member/client": "Член/клиент",
    "Member/date": "Член/дата",
    "Date/member": "Дата/член",
    "Grouped": "Обединен",
    "Client/project": "Client/project",
    "Project/member": "Project/member",
    "Period balance": "Period balance",
    "Reset balance": "Reset balance",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Time entry has been confirmed or duration has been changed and duration will not dynamically update",
    "(Without project)": "(Without project)",
    "Decline": "Decline",
    "Accept": "Accept",
    "Cancel decision": "Cancel decision",
    "Accepted": "Accepted",
    "Declined": "Declined",
    "Report data has changed. Please update report.": "Данните за отчета са променени. Актуализирайте отчета.",
    "Agreed": "Agreed",
    "Non billable": "Не се таксува",
    "Export report to Excel": "Експортиране на отчет в Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "По подразбиране експортираме резултата от избраните филтри с колоните на конфигурираната таблица",
    "Add to export client custom fields": "Добавяне към потребителски полета на клиента за експортиране",
    "Save report": "Запиши отчета",
    "Export PDF": "Експортиране на PDF",
    "Export Excel": "Експортиране на Excel",
    "We have new version of": "We have a new version of",
    "Log out": "Изход",
    "Previous day": "Предишен ден",
    "Next day": "На следващия ден",
    "Mark all as read": "Отбележи всички като прочетени",
    "Search task/client": "Search",
    "from client portal": "от клиентски портал",
    "Hide all": "Скриване на всички",
    "Hide for 1 hour": "Скриване за 1 час",
    "Something went wrong": "Нещо се обърка",
    "User authentication needed": "User authentication required",
    "Invalid rights": "Невалидни права",
    "The object cannot be found": "Обектът не може да бъде намерен",
    "Content too large": "Съдържанието е твърде голямо",
    "An unknown error occurred": "Възникна неизвестна грешка",
    "The action requested cannot be performed": "Исканото действие не може да бъде изпълнено",
    "Go": "Напред",
    "Actual / monitoring (month)": "Действителен / мониторинг (месец)",
    "h": "ч",
    "Actual": "Действителен",
    "Month": "Месец",
    "I’m setting up your account": "Настройвам акаунта ти",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Знаете ли, че счетоводните фирми, които са започнали да използват Uku, могат да обслужват 38% повече клиенти едновременно.",
    "Let’s setup your company": "Let’s set up your company",
    "Name of your company": "Име на Вашата фирма",
    "Size of your team?": "Размерът на вашия екип?",
    "Which software are you using?": "Какъв софтуер използвате?",
    "This knowledge will help us to improve Uku": "Това знание ще ни помогне да подобрим Уку",
    "What other software needs to be integrated?": "Какъв друг софтуер трябва да бъде интегриран?",
    "Book a demo": "Резервирайте демо",
    "Hi {0},": "Здравейте {0},",
    "NO BOTS - ONLY HUMANS": "НЯМА БОТОВЕ - САМО ХОРА",
    "Start a 14 day free trial": "Започнете 14-дневен безплатен пробен период",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "Uku is incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Най-бързият начин да решите дали Uku може да се възползва {0} е кратък {1}-минутен разговор с нашия клиентски специалист.",
    "Hi, I'm Uku ": "Здравейте, аз съм Уку ",
    "I help to set up your account.": "I will help to set up your account.",
    "It only takes a minute.": "Отнема само минута.",
    "Choose": "Изберете",
    "Your country": "Вашата страна",
    "Your language": "Вашият език",
    "Begin": "Начало",
    "Let’s become friends": "Да станем приятели",
    "Your first name": "Вашето собствено име",
    "What is your field of work?": "Каква е вашата сфера на работа?",
    "Your field of work": "Вашата сфера на работа",
    "How will you use Uku?": "Как ще използвате Uku?",
    "How did you hear about Uku?": "Как разбрахте за Уку?",
    "Choose channel": "Изберете канал",
    "Please specify how you heard about us": "Моля, уточнете как сте чули за нас",
    "Let me know Uku's new features by email": "Уведомете ме за новите функции на Uku по имейл",
    "Finish": "Готово",
    "First name is required": "Първо име Се изисква",
    "Name is required": "Имена е задължително поле",
    "Team size is required": "Изисква се размер на екипа",
    "Surname is required": "Фамилията е задължителна",
    "Field is required": "Полето е задължително",
    "I will use Uku to work together with two or more teammates.": "Ще използвам Уку, за да работя заедно с двама или повече съотборници.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Аз ще използвам Uku от себе си. Този план е безплатен, но функциите са ограничени.",
    "Media": "Медия",
    "Through integration partner": "Through an integration partner",
    "Referral by friend": "Referral by a friend",
    "Import speeds up your clients setup, smart choice!": "Вносът ускорява настройката на вашите клиенти, интелигентен избор!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Последно импортиране: добавен {0}, актуализиран {1}, пропуснат {2}, неуспешно импортиране {3} клиента",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Последно импортиране: добавен {0}, актуализиран {1}, пропуснат {2}, неуспешно импортиране {3} клиенти",
    "Last import: added {0}, updated {1}, skipped {2}": "Последно импортиране: добавено {0}, актуализирано {1}, пропуснато {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Какво следва? Коригирайте данните на {0} клиенти и качете отново.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Вместо да въвеждате клиенти един по един, можете да използвате импортиране на файлове за голяма клиентска база.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Импортирайте всички клиенти на Merit Aktiva и поддържайте данните на клиентите автоматично актуализирани",
    "Ignore": "игнорирайте",
    "NEW CLIENT": "НОВ КЛИЕНТ",
    "Preview": "Преглед",
    "Import started": "Импортирането започна",
    "Only new clients": "Само нови клиенти",
    "Update data from company register": "Актуализиране на данни от фирмения регистър",
    "If switched on, the company data is updated using the local business register": "Ако са включени, фирмените данни се актуализират с помощта на местния търговски регистър",
    "We did not find a match in Äriregister": "Не намерихме съвпадение в Äriregister",
    "We did not find a match in Companies House": "Не намерихме съвпадение в Companies House",
    "No integration yet": "Все още няма интеграция",
    "Uku match": "Уку мач",
    "Business register nr.": "Business register no.",
    "Company register": "Фирмен регистър",
    "Upload file": "Качи файл",
    "Before uploading your file": "Преди да качите файла си",
    "Learn Uku’s data structure": "Научете структурата от данни на Uku",
    "Download and use our sample file to see exactly how we organize data in Uku": "Изтеглете и използвайте нашия примерен файл, за да видите как точно организираме данните в Uku",
    "Download Client Import Example": "Изтегляне на пример за импортиране на клиент",
    "Download Contact Import Example": "Изтегляне на пример за импортиране на контакт",
    "Fill in fields": "Попълнете полетата",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Единственото задължително поле е името на фирмата. Уверете се, че сте попълнили всички необходими полета, преди да качите файла.",
    "Learn more about mandatory fields": "Научете повече за задължителните полета",
    "Create custom fields": "Създаване на потребителски полета",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Някои полета за данни може да не присъстват по подразбиране. Уверете се, че сте създали тези полета по избор, преди да импортирате данните си.",
    "Add new custom fields": "Добавяне на нови полета по избор",
    "...or drag a file here": "... или плъзнете файл тук",
    "Only Excel (.xls, .xlsx) file types are supported": "Only Excel (.xls, .xlsx) file types are supported",
    "Mapping": "Картиране",
    "First row is a header": "Първият ред е горен колонтитул",
    "Add field to all clients": "Добавяне на поле към всички клиенти",
    "Add client group": "Добавяне на клиентска група",
    "Fields for all clients": "Полета за всички клиенти",
    "Import of {0} in progress": "В процес на импортиране на {0}",
    "Import in progress": "Извършва се импортиране",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Може да отнеме известно време. Можете да правите други дейности в Uku по същото време, ние ще ви уведомим, когато е готов.",
    "Cancel import": "Отмяна на импортирането",
    "Are you sure you want to cancel import?": "Наистина ли искате да отмените импортирането?",
    "Last updated": "Последен Ъпдейт",
    "Contracts": "Други резерви по застрахователни договори",
    "Job name": "Име на длъжността",
    "Workflow name": "Име на работния поток",
    "Details": "Детайли",
    "Select jobs": "Избор на задания",
    "Select task plan": "Избор на план на задача",
    "of existing client": "на съществуващ клиент",
    "You can also choose": "Можете също така да изберете",
    "existing client tasks plan": "План за съществуващи клиентски задачи",
    "existing predefined jobs": "съществуващи предварително дефинирани задания",
    "create a new plan": "Създаване на нов план",
    "Select workflow": "Избор на работен поток",
    "existing project workflow": "съществуващ работен поток на проект",
    "existing workflow": "съществуващ работен поток",
    "create a new workflow": "Създаване на нов работен поток",
    "New tasks template": "Шаблон за нови задачи",
    "to save template!": "за да запазите шаблона!",
    "You can also add tasks from jobs": "Можете също да добавяте задачи от работни места",
    "or choose": "или изберете",
    "New workflow template": "Нов шаблон за работен поток",
    "You can also add tasks from existing workflow templates": "Можете също да добавяте задачи от съществуващи шаблони за работни потоци",
    "existing event workflow": "съществуващ работен поток за събития",
    "Hide others": "Скриване на другите",
    "Update all events (New tasks)": "Актуализиране на всички събития (Нови задачи)",
    "Update all projects (New tasks)": "Актуализиране на всички проекти (Нови задачи)",
    "Once": "Веднъж",
    "Once a month": "Веднъж месечно",
    "Once a quarter": "Веднъж на тримесечие",
    "Once a year": "Веднъж годишно",
    "Company workflow": "Работен процес на фирмата",
    "Company jobs": "Фирмени работни места",
    "Default jobs": "Задания по подразбиране",
    "ID": "Номер (ID)",
    "Task title and labels": "Заглавие на задачата и етикети",
    "Assigned and time": "Възложено и време",
    "Setup tasks for {0} event": "Настройване на задачи за {0} събитие",
    "Setup tasks for {0} project": "Настройване на задачи за {0} проект",
    "New job": "Нова работа",
    "Edit job": "Редактирай услугата",
    "New workflow": "Нов работен поток",
    "Save workflow": "Записване на работния поток",
    "Create task plan": "Създаване на план на задача",
    "Confirm task plan": "Потвърждаване на плана на задачата",
    "Skip": "Пропусни",
    "Confirm workflow": "Потвърждаване на работния поток",
    "Client portal templates": "Шаблони за клиентски портали",
    "Jobs": "Обяви",
    "Workflows": "Работни потоци",
    "Company workflows": "Company workflows",
    "Default workflows": "Default workflows",
    "Company template saved": "Company template saved",
    "Company template created": "Company template created",
    "Format": "Format",
    "Currency": "Валута",
    "Reference number": "Референтен номер",
    "Invoice description": "Описание на фактурата",
    "Summarize invoice rows": "Summarise invoice rows",
    "Summarized description": "Summarised description",
    "Reverse charge": "Обратно начисляване",
    "Rounding": "Закръгляне",
    "Time rounding will apply for each line": "Time rounding will apply for each line",
    "Rounding increment (up)": "Нарастване на закръгляването (нагоре)",
    "Reply to": "Отговор до",
    "Configuration": "Configuration",
    "Invoice to parent company": "Invoice to parent company",
    "Create all invoices under parent company.": "Create all invoices under parent company.",
    "User code": "Потребителски код",
    "Default": "Default",
    "Default value will apply for each line": "Default value will apply for each line",
    "Number": "Номер",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Можете да напишете всяко от следните неща във фигурни скоби в полето за префикс на фактура. При запазване на договора префиксът се попълва със съответната стойност.",
    "Copy to clipboard": "Копирай в клипборда",
    "Invoice previous period": "Предходен период на фактуриране",
    "Invoice period": "Период на фактуриране",
    "Invoice next period": "Фактура за следващия период",
    "Client primary user": "Основен потребител на клиента",
    "Original client name": "Original client name",
    "invoice date year": "дата на фактура година",
    "last two digits of invoice date year": "последните две цифри от датата на фактурата година",
    "invoice date month": "Дата на фактурата месец",
    "invoice date day": "Дата на фактурата Ден",
    "Copied to clipboard": "Копирано в клипборда",
    "Contract": "Договор",
    "Net total": "Net total",
    "Contract #": "Contract #",
    "Invoice #": "Invoice no.",
    "Exported": "Изнасяни",
    "Sent": "Изпратено",
    "Net": "Нето",
    "Add invoice": "Добавяне на фактура",
    "Change invoice number": "Промяна на номера на фактурата",
    "Review changes": "Преглед на промените",
    "Please review and approve changes to the related events": "Please review and approve changes to the related events",
    "Please review and approve changes to the related projects": "Please review and approve changes to the related projects",
    "Contains": "Съдържа",
    "contains": "съдържа",
    "Exactly": "Точно",
    "is exactly": "е точно",
    "Greater than": "По-голямо от",
    "is greater than": "е по-голямо от",
    "Less than": "По-малко от",
    "is less than": "е по-малко от",
    "Range": "Диапазон",
    "is in range of": "is in the range of",
    "is empty": "is empty",
    "Task plan": "План на задачата",
    "Edit plan": "Редактиране на план",
    "Use task plan templates to set up tasks effectively or add a task manually": "Use task plan templates to set up tasks effectively or add a task manually",
    "Add task manually": "Add task manually",
    "Quarterly": "На три месеца",
    "Export excel": "Export excel",
    "Print PDF": "Печат на PDF",
    "Edit jobs": "Редактиране на задания",
    "Replace plan tasks with job": "Заместване на задачи от плана с проект",
    "Select template": "Изборете шаблон",
    "member": "член",
    "Tasks with user will be added to every selected client": "Задачите с потребителя ще бъдат добавени към всеки избран клиент",
    "Add even if job already applied": "Добавяне, дори ако заданието вече е приложено",
    "Default user": "Потребител по подразбиране",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Това ще изтрие всички задачи от клиентския план и ще постави само задачите на избрания шаблон в него",
    "Adding template will be ready in a minute. You can continue with work.": "Added template will be ready soon. You can continue with your work.",
    "Add client": "Добавяне на клиент",
    "Export clients": "Експортни клиенти",
    "Export client contacts": "Експортиране на контакти на клиенти",
    "client | clients": "клиент | Клиенти",
    "clients": "Клиенти",
    "client(s) had errors": "клиент(и) са имали грешки",
    "client(s) selected": "Избран(и) клиент(и)",
    "Contract actions": "Действия по договор",
    "Edit Members": "Редактиране на членове",
    "Edit monitoring": "Редактиране на мониторинг",
    "Your company": "Вашата компания",
    "Edit billing": "Редактиране на фактуриране",
    "Activate client portal": "Активиране на клиентски портал",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "След активиране можете да изпращате задачи директно до всички контакти на клиента, които имат имейл адрес.",
    "Send welcome invitation to client contacts": "Изпращане на покана за добре дошли до контактите на клиента",
    "Who will receive an invitation?": "Кой ще получи покана?",
    "Client contact who has one valid e-mail address": "Контакт с клиент, който има един валиден имейл адрес",
    "Client contact who has the client's portal open (default for all)": "Контакт с клиент, който е отворил портала на клиента (по подразбиране за всички)",
    "How does the invitation work?": "Как работи поканата?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku създава и изпраща \"Добре дошли задача\" на всеки клиент контакт. Той е създаден от основния потребител на клиента въз основа на шаблона за задачи \"Добре дошли в портала за клиенти\". Прегледайте го под шаблоните за задачи на вашата фирма. Тя ще бъде преведена според езика за контакт.",
    "Uku client portal always informs clients by email about new tasks.": "Клиентският портал на Uku винаги информира клиентите по имейл за нови задачи.",
    "View templates": "Преглед на шаблони",
    "Client portal activated": "Клиентският портал е активиран",
    "Company's name": "Company name",
    "Mark": "Знак",
    "Add members": "Добавяне на членове",
    "Members and groups": "Членове и групи",
    "Topic is required": "Темата е задължителна",
    "Entering time is required": "Изисква се време за въвеждане",
    "Delete client": "Изтриване на клиент",
    "Manage client fields": "Управление на клиентски полета",
    "Max 3 characters": "Максимум 3 символа",
    "Are you sure you wish to delete this client?": "Are you sure you want to delete this client?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Изтриването на клиентски данни също ще изтрие всички задачи, свързани с клиента.<br/><br/>НБ! Историята на клиентите ще бъде изтрита",
    "Owner": "Собственик",
    "All clients that you add under {0} will be deleted later.</div>": "Всички клиенти, които добавите под {0} , ще бъдат изтрити по-късно.",
    "Use this account for testing purposes only!": "Използвайте този акаунт само за тестови цели!",
    "Read more about the demo account": "Прочетете повече за демо сметката",
    "Rights": "Права",
    "Monitoring setup": "Настройка на мониторинга",
    "Learn more about monitoring": "Научете повече за мониторинга",
    "selected": "избрано",
    "Invoicing": "Фактуриране",
    "Billing template": "Шаблон за фактуриране",
    "New": "Нов",
    "Add row": "Добавяне на ред",
    "Delete contract": "Изтриване на договор",
    "Product / description": "Продукт / описание",
    "Qty": "Количество",
    "Product placeholders": "Контейнери за продукти",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Новия шаблон е запазен",
    "Warning": "Внимание",
    "Would you like to apply these changes to all clients using this contract template?": "Желаете ли да приложите тези промени към всички клиенти, като използвате този шаблон за договор?",
    "Yes, apply to all clients": "Да, важи за всички клиенти",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "You have made changes to the time period that this billing contract appliesto. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.",
    "Are you sure to delete this template?": "Are you sure you want to delete this template?",
    "Save template": "Запиши шаблона",
    "Save as template": "Запиши като шаблон",
    "Please note all changes made to contract will be lost": "Моля, имайте предвид, че всички промени, направени в договора, ще бъдат загубени",
    "Add contract": "Добавяне на договор",
    "Manage contract templates": "Управление на шаблони за договори",
    "Change account details": "Edit account details",
    "Country is required": "Изисква се държава",
    "Address": "Адрес",
    "Postal code": "Postcode",
    "State": "County",
    "Uku is set up according to the field of work.": "Уку е създаден според сферата на работа.",
    "Size of the team": "Размер на екипа",
    "Website": "Website",
    "Delete account": "Изтриване на профила",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Изтриването на акаунт също ще изтрие всички клиенти, свързани с акаунта, техните задачи и цялата им история. Наистина ли искате да изтриете акаунта си?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Да, изтрийте акаунта с всички свързани данни, като например клиенти, задачи и цялата история",
    "These invoices cannot be sent. Check their status or error messages.": "Тези фактури не могат да бъдат изпратени. Проверете тяхното състояние или съобщения за грешки.",
    "Please confirm that you wish to proceed.": "Моля, потвърдете, че желаете да продължите.",
    "Sending invoice | Sending invoices": "Изпращане на фактура | Изпращане на фактури",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "You are about to e-mail this invoice to the customer. | You are about to e-mail these invoices to customers.",
    "Error in calculating invoice": "Грешка при изчисляване на фактура",
    "Error in importing invoice": "Error in importing invoice",
    "Error in creating invoice": "Грешка при създаване на фактура",
    "Error in exporting invoice": "Грешка при експортиране на фактура",
    "Error in sending invoice": "Грешка при изпращане на фактура",
    "Calculating invoice": "Изчисляване на фактура",
    "Creating invoice": "Създаване на фактура",
    "Exporting invoice": "Експортиране на фактура",
    "Importing invoice": "Importing invoice",
    "Sending invoice": "Изпращане на фактура",
    "Clear errors": "Изчистване на грешките",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Свързаната работа ще бъде таксувана отново. Фактурите няма да бъдат изтрити от външни системи, ще трябва да направите това ръчно.",
    "Delete invoice | Deleting invoices": "Изтриване на фактура | Изтриване на фактури",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Нищо във фактурите",
    "Please make sure you have setup recurring billing for your clients": "Please make sure you have set up recurring billing for your clients",
    "Draft": "Чернова",
    "Approval": "Одобрение",
    "Created": "Създаден",
    "Coming soon": "Скоро предстои",
    "Selected invoices and related product info will be sent to accounting system.": "Selected invoices and related product info will be sent to the accounting system.",
    "Piece": "Парче",
    "Hour": "Час",
    "Delete row": "Изтриване на ред",
    "Out of ": "Извън ",
    " can be created": " могат да бъдат създадени",
    "For ": "За ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " Периодът на фактуриране все още продължава. Всяка работа, извършена в този период след създаването на фактурата, няма да бъде фактурирана.",
    "Invoice date will be set to today.": "Датата на фактурата ще бъде зададена на днес.",
    "Uku is about to create": "Uku е на път да създаде",
    " selected row, only | selected row, only ": " избран ред, само | избран ред, само ",
    " invoice | invoices": " фактура | Фактури",
    "These invoices cannot be exported. Check their status or error messages.": "These invoices cannot be exported. Check their status or error messages.",
    "Exporting invoice | Exporting invoices": "Експортиране на фактура | Експортиране на фактури",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "На път сте да експортирате тази фактура в счетоводството. | На път сте да експортирате тези фактури в счетоводството.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "Download PDF",
    "Create invoice": "Създаване на фактура",
    "Update status from {0}": "Update status from {0}",
    "Show all lines": "Show all lines",
    "Calculate invoice": "Calculate invoice",
    "Loading invoice...": "Зареждане на фактура...",
    "Invalid Scoro credentials": "Невалидни идентификационни данни на Scoro",
    "Please confirm the changes you have made to this invoice.": "Моля, потвърдете промените, които сте направили в тази фактура.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.",
    "Invoice number already exists! Please confirm to save anyway.": "Номерът на фактурата вече съществува! Моля, потвърдете, за да запазите така или иначе.",
    "Error in data": "Error in data",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Периодът на фактуриране все още продължава. Всяка работа, извършена в този период след създаването на фактурата, няма да бъде фактурирана.",
    "Creation date": "Дата на създаване",
    "{0} days after": "{0} дни след",
    "{0} day after": "{0} ден след",
    "right away when": "Веднага, когато",
    "start date": "Начална дата",
    "due date": "Дата на падеж",
    "finished": "приключили",
    "Entries count": "Брой записи",
    "Entries excluding sales": "Записи, с изключение на продажбите",
    "Entries excluding bank": "Записи с изключение на банка",
    "Entries excluding documents": "Вписвания, с изключение на документи",
    "Documents (sales and purchases)": "Документи (продажби и покупки)",
    "Cash entries": "Касови записи",
    "VAT entries": "Записи за ДДС",
    "Stock entries": "Складови записи",
    "Sale entries": "Записи за продажба",
    "Purchase entries": "Записи за покупки",
    "Bank entries": "Банкови записи",
    "Ledger entries": "Счетоводни записи",
    "Depreciation entries": "Амортизационни записи",
    "Entry lines count": "Брой на входните редове",
    "Company owner": "МОЛ",
    "Activity": "Активност",
    "Oldest first": "Първо най-стари",
    "Newest first": "Първо най-нови",
    "Quantity as time": "Количеството като време",
    "Quantity as number": "Количество като число",
    "Quantity as time in number format": "Quantity as time in number format",
    "No rounding": "Без закръгляване",
    "min": "мин",
    "hour": "час",
    "Last day of month": "Последен ден от месеца",
    "Invoice line": "Invoice line",
    "Task time total (per member)": "Task time total (per member)",
    "Time entry": "Time entry",
    "Task finish date": "Task finish date",
    "Create separately": "Create separately",
    "Merge into one": "Merge into one",
    "No minimum": "Без минимум",
    "{0} minute": "{0} минута",
    "{0} minutes": "{0} минути",
    "{0} hour": "{0} часа",
    "{0} hours": "{0} часа",
    "English": "English",
    "Estonian": "Estonian",
    "Danish": "Danish",
    "Lithuanian": "Lithuanian",
    "Russian": "Russian",
    "Finnish": "Finnish",
    "Swedish": "Swedish",
    "Norwegian": "Norwegian",
    "Latvian": "Latvian",
    "Bulgarian": "Bulgarian",
    "German": "German",
    "Spanish": "Spanish",
    "Polish": "Polish",
    "Field: ": "Поле: ",
    "Normal hours": "Нормални часове",
    "Year": "Година",
    "Estonia": "Estonia",
    "Finland": "Finland",
    "Poland": "Poland",
    "Connection successful!": "Връзката е успешна!",
    "User": "Потребител",
    "None": "Без",
    "Error!": "Грешка!",
    "Pending": "Изчаква одобрение",
    "Finished": "Завършен",
    "Text": "Текст",
    "Choice": "Избор",
    "Yes/No": "Да/Не",
    "Integer": "Цяло число",
    "Multiple choice": "Множествен избор",
    "URL": "URL",
    "Multiple users": "Множество потребители",
    "Multiline text": "Многоредов текст",
    "Must be a integer": "Must be an integer",
    "Must be a date": "Трябва да е дата",
    "Must be a valid e-mail address": "Трябва да е валиден имейл адрес",
    "Unknown choice": "Неизвестен избор",
    "Some errors occurred:": "A few errors occurred",
    "Unknown network error": "Неизвестна мрежова грешка",
    "Could not connect to the service": "Не можа да бъде установена връзка с услугата",
    "Reload this page": "Please reload this page",
    "Invoice paid": "Платена фактура",
    "Annulled": "Cancelled",
    "Processing": "Обработка",
    "You are about to deactivate this app.": "You are about to deactivate this app.",
    "You are about to disconnect this app.": "You are about to disconnect this app.",
    "Do you also want to activate billing to get the most out of Uku?": "Do you also want to activate billing to get the most out of Uku?",
    "Invoice": "Invoice",
    "Clients - Monitoring": "Клиенти - Мониторинг",
    "Links": "Връзки",
    "New template": "Нов шаблон",
    "Import Clients from Excel": "Import clients from Excel",
    "Importer": "Вносител",
    "Import clients from Excel": "Импортиране на клиенти от Excel",
    "Account settings": "Настройки на акаунт",
    "Empty": "Празен",
};
export default translations